import axios from "./http";
import * as apis from "@/api/apis.js";
import QRCode from "qrcode";
import html2canvas from "html2canvas";
let baseUrl = "";

export function getHuozhuLastPici(params) {
	return axios.post(`${baseUrl}/syapi/Huozhu/getHuozhuLastPici`, params);
}
export function getProductList(params) {
	return axios.post(`${baseUrl}/syapi/goods/lists`, params);
}
//登录
export function login(params) {
	return axios.post(`${baseUrl}/syapi/cashier/login`, params);
}
//获取测试账号
export function accountTest(params) {
	return axios.post(`${baseUrl}/syapi/cashier/accountTest`, params);
}
//获取商品所有分类
export function allCategory(params) {
	return axios.post(`${baseUrl}/syapi/category/lists`, params);
}
//获取商品所有一级分类
export function categoryone(params) {
	return axios.post(`${baseUrl}/syapi/category/categoryone`, params);
}
//获取商品所有二级分类
export function categorytwo(params) {
	return axios.post(`${baseUrl}/syapi/category/categorytwo`, params);
}

//获取商品所有一级分类
export function categoryoneCloud(params) {
	return axios.post(`${baseUrl}/syapi/category/categoryoneCloud`, params);
}
//获取商品所有二级分类
export function categorytwoCloud(params) {
	return axios.post(`${baseUrl}/syapi/category/categorytwoCloud`, params);
}

//获取商品所有分类
export function updateSelfStatus(params) {
	return axios.post(`${baseUrl}/syapi/goods/updateSelfStatus`, params);
}
export function getSelfKeywords(params) {
	return axios.post(`${baseUrl}/syapi/goods/getSelfKeywords`, params);
}
export function getCloudKeywords(params) {
	return axios.post(`${baseUrl}/syapi/goods/getCloudKeywords`, params);
}
//获取商品所有分类
export function getInventoryListData(params) {
	return axios.post(`${baseUrl}/syapi/goods/getInventoryListData`, params);
}

//获取商品所有分类
export function handPayment(params) {
	return axios.post(`${baseUrl}/syapi/goods/handPayment`, params);
}

//获取商品所有分类
export function categoryListsSelf(params) {
	return axios.post(`${baseUrl}/syapi/category/lists`, params);
}

//添加商品分类
export function addCategory(params) {
	return axios.post(`${baseUrl}/syapi/category/add`, params);
}
//获取订单列表
export function getOrderList(params) {
	return axios.post(`${baseUrl}/syapi/order/lists`, params);
}
//获取当前分类下的商品
export function getCategoryGoods(params) {
	return axios.post(`${baseUrl}/syapi/goods/lists`, params);
}

//获取当前分类下的商品
export function getSelfCategoryGoods(params) {
	return axios.post(`${baseUrl}/syapi/goods/getSelfCategoryGoods`, params);
}
export function getPiciInfo(params) {
	return axios.post(`${baseUrl}/syapi/pici/getPiciInfo`, params);
}
export function updatePici(params) {
	return axios.post(`${baseUrl}/syapi/pici/updatePici`, params);
}
//获取当前分类下的商品
export function getCloudCategoryGoods(params) {
	return axios.post(`${baseUrl}/syapi/goods/getCloudCategoryGoods`, params);
}
//获取当前分类下的商品
export function cloudToSelf(params) {
	return axios.post(`${baseUrl}/syapi/goods/cloudToSelf`, params);
}
//获取当前分类下的商品
export function pingdanLog(params) {
	return axios.post(`${baseUrl}/syapi/Statistics/pingdanLog`, params);
}

export function getGoodsHistoryPrice(params) {
	return axios.post(`${baseUrl}/syapi/goods/historyPrice`, params);
}

export function kaidanDataCar(params) {
	return axios.post(`${baseUrl}/syapi/order/kaidanDataCar`, params);
}

export function getLastOrder(params) {
	return axios.post(`${baseUrl}/syapi/order/getLastOrder`, params);
}

export function dataCar(params) {
	return axios.post(`${baseUrl}/syapi/order/dataCar`, params);
}
export function deleteCar(params) {
	return axios.post(`${baseUrl}/syapi/order/deleteCar`, params);
}
export function addHuozhuData(params) {
	return axios.post(`${baseUrl}/syapi/Huozhu/addHuozhuData`, params);
}
export function getAllHuozhuData(params) {
	return axios.post(`${baseUrl}/syapi/Huozhu/getAllHuozhuData`, params);
}
export function addPiciData(params) {
	return axios.post(`${baseUrl}/syapi/Pici/addPiciData`, params);
}
export function getAllPiciData(params) {
	return axios.post(`${baseUrl}/syapi/Pici/getAllPiciData`, params);
}
export function getUnitData(params) {
	return axios.post(`${baseUrl}/syapi/Goods/getUnitData`, params);
}
export function delHuozhuData(params) {
	return axios.post(`${baseUrl}/syapi/huozhu/delHuozhuData`, params);
}
export function delPiciData(params) {
	return axios.post(`${baseUrl}/syapi/Pici/delPiciData`, params);
}
export function updatePiciData(params) {
	return axios.post(`${baseUrl}/syapi/Pici/updatePiciData`, params);
}
export function extendUnitData(params) {
	return axios.post(`${baseUrl}/syapi/Goods/extendUnitData`, params);
}
export function updateUnitData(params) {
	return axios.post(`${baseUrl}/syapi/Goods/updateUnitData`, params);
}

export function extendUnitDelData(params) {
	return axios.post(`${baseUrl}/syapi/Goods/extendUnitDelData`, params);
}
export function updateGuigeData(params) {
	return axios.post(`${baseUrl}/syapi/Goods/updateGuigeData`, params);
}

export function addMaijiaCar(params) {
	return axios.post(`${baseUrl}/syapi/order/addMaijiaCar`, params);
}
export function getMaijiaCar(params) {
	return axios.post(`${baseUrl}/syapi/order/getMaijiaCar`, params);
}
export function addmj(params) {
	return axios.post(`${baseUrl}/syapi/order/addmj`, params);
}
export function addOrderData(params) {
	return axios.post(`${baseUrl}/syapi/order/addOrderData`, params);
}

//查询会员信息
export function getMemberInfo(params) {
	return axios.post(`${baseUrl}/syapi/member/searcheShouyinMember`, params);
}
//查询会员信息
export function getMember(params) {
	return axios.post(`${baseUrl}/syapi/order/getMember`, params);
}
// 删除商品分类
export function getdelInfo(params) {
	return axios.post(`${baseUrl}/syapi/category/del`, params);
}
// 编辑商品分类
export function getedcategoryInfo(params) {
	return axios.post(`${baseUrl}/syapi/category/edcategory`, params);
}
//删除商品
export function delGoods(params) {
	return axios.post(`${baseUrl}/syapi/goods/delGoods`, params);
}
//添加商品
export function addGoods(params) {
	return axios.post(`${baseUrl}/syapi/goods/add`, params);
}
//添加商品
export function exportGoodsData(params) {
	return axios.post(`${baseUrl}/syapi/goods/exportGoodsData`, params);
}

//添加商品
export function addSelf(params) {
	return axios.post(`${baseUrl}/syapi/goods/addSelf`, params);
}
//获取商品规格项
export function getGoodsSpec(params) {
	return axios.get(`${baseUrl}/syapi/goods/goodsspec`, params);
}

// 编辑商品保存
export function updateGoodsInfo(params) {
	return axios.post(`${baseUrl}/syapi/goods/editsave`, params);
}

// 修改商品分类
export function updateGoodsType(params) {
	return axios.post(`${baseUrl}/syapi/goods/edcategory`, params);
}
//修改商品分类
export function changeCategray(params) {
	return axios.post(`${baseUrl}/syapi/category/ed`, params);
}
//获取订单详情
export function getOrderDetailData(params) {
	return axios.post(`${baseUrl}/syapi/order/getOrderDetailData`, params);
}

//获取订单详情
export function getOrderDetailPrint(params) {
	return axios.post(`${baseUrl}/syapi/order/getOrderDetailPrint`, params);
}
//获取订单详情
export function getOrderPrint(params) {
	return axios.post(`${baseUrl}/syapi/order/getOrderPrint`, params);
}

//获取订单详情
export function getOrderData(params) {
	return axios.post(`${baseUrl}/syapi/order/getOrderData`, params);
}

export function getOrderByOrderIdData(params) {
	return axios.post(`${baseUrl}/syapi/order/getOrderByOrderIdData`, params);
}

//作废订单
export function zuofeiOrderData(params) {
	return axios.post(`${baseUrl}/syapi/order/zuofeiOrderData`, params);
}
//修改订单
export function updateOrderData(params) {
	return axios.post(`${baseUrl}/syapi/order/updateOrderData`, params);
}

//作废订单
export function getZuofeiOrderDetailData(params) {
	return axios.post(`${baseUrl}/syapi/order/getZuofeiOrderDetailData`, params);
}

//挂单数据
export function getMaijiaCarqudan(params) {
	return axios.post(`${baseUrl}/syapi/order/getMaijiaCarqudan`, params);
}

//挂单操作
export function guadanData(params) {
	return axios.post(`${baseUrl}/syapi/order/guadanData`, params);
}
//批量改价获取数据
export function updateData(params) {
	return axios.post(`${baseUrl}/syapi/order/updateData`, params);
}

//批量改价获取数据
export function fenjianData(params) {
	return axios.post(`${baseUrl}/syapi/order/fenjianData`, params);
}
//批量改价提交数据
export function updatePriceData(params) {
	return axios.post(`${baseUrl}/syapi/order/updatePriceData`, params);
}

//挂单回购物车
export function guadantocar(params) {
	return axios.post(`${baseUrl}/syapi/order/guadantocar`, params);
}
//挂单回购物车
export function addHuozhuDataShangpin(params) {
	return axios.post(`${baseUrl}/syapi/huozhu/addHuozhuDataShangpin`, params);
}
//挂单回购物车
export function addPiciDataShangpin(params) {
	return axios.post(`${baseUrl}/syapi/pici/addPiciDataShangpin`, params);
}
//挂单回购物车
export function getUserInfo(params) {
	return axios.post(`${baseUrl}/syapi/member/getUserInfo`, params);
}
// 修改用户信息
export function updateUserInfo(params) {
	return axios.post(`${baseUrl}/syapi/member/updateUserInfo`, params);
}
//查看账期
export function lookBookData(params) {
	return axios.post(`${baseUrl}/syapi/Statistics/lookBookData`, params);
}
//查看交班数据
export function getStatisticsData(params) {
	return axios.post(`${baseUrl}/syapi/Statistics/getStatisticsData`, params);
}
//添加支出项目
export function addZhichuData(params) {
	return axios.post(`${baseUrl}/syapi/Statistics/addZhichuData`, params);
}
//添加批次支出项目
export function addPiciZhichuData(params) {
	return axios.post(`${baseUrl}/syapi/Statistics/addPiciZhichuData`, params);
}
//获取所有的费用项
export function getAllFeiyongxiangData(params) {
	return axios.post(
		`${baseUrl}/syapi/Statistics/getAllFeiyongxiangData`,
		params
	);
}
//添加费用项
export function addFeiyongxiangData(params) {
	return axios.post(`${baseUrl}/syapi/Statistics/addFeiyongxiangData`, params);
}
//删除费用项
export function delFeiyongxiangData(params) {
	return axios.post(`${baseUrl}/syapi/Statistics/delFeiyongxiangData`, params);
}

//获取统计页面的订单
export function getStatisticsOrderData(params) {
	return axios.post(
		`${baseUrl}/syapi/Statistics/getStatisticsOrderData`,
		params
	);
}
//获取统计页面的订单
export function jiaozhangData(params) {
	return axios.post(`${baseUrl}/syapi/Statistics/jiaozhangData`, params);
}
//获取支出数据
export function getZhichuOrderData(params) {
	return axios.post(`${baseUrl}/syapi/Statistics/getZhichuOrderData`, params);
}
//删除支出数据
export function deleteZhichuData(params) {
	return axios.post(`${baseUrl}/syapi/Statistics/deleteZhichuData`, params);
}
//还款数据
export function huankuanData(params) {
	return axios.post(`${baseUrl}/syapi/order/huankuanData`, params);
}
//查看统计的支付类型数据
export function lookPayTypeOrderData(params) {
	return axios.post(`${baseUrl}/syapi/Statistics/lookPayTypeOrderData`, params);
}
//查看统计的支付类型数据
export function getHuankuanData(params) {
	return axios.post(`${baseUrl}/syapi/order/getHuankuanData`, params);
}
//查看统计的支付类型数据
export function lookHuankuanOrderDetailData(params) {
	return axios.post(
		`${baseUrl}/syapi/order/lookHuankuanOrderDetailData`,
		params
	);
}

//打印拆单数据
export function orderGetPrintOrder(params) {
	return axios.post(`${baseUrl}/syapi/order/orderGetPrintOrder`, params);
}

//撤销还款订单
export function revokeOrderData(params) {
	return axios.post(`${baseUrl}/syapi/order/revokeOrderData`, params);
}

//还款订单详情
export function getHuankuanDetailData(params) {
	return axios.post(`${baseUrl}/syapi/order/getHuankuanDetailData`, params);
}
//还款订单详情
export function addLuruData(params) {
	return axios.post(`${baseUrl}/syapi/Statistics/addLuruData`, params);
}

//还款订单详情
export function formatData(params) {
	return axios.post(`${baseUrl}/syapi/batch/formatData`, params);
}

// 飞蛾打印
export function orderListPrint(params) {
	return axios.post(`${baseUrl}/syapi/dayin/orderListPrint`, params);
}
export function orderTestPrint(params) {
	return axios.post(`${baseUrl}/syapi/dayin/orderTestPrint`, params);
}
// 飞蛾打印

//订单退款
export function refund(params) {
	return axios.post(`${baseUrl}/syapi/order/refund`, params);
}

// 批量修改售价
export function updateGoodsPrice(params) {
	return axios.post(`${baseUrl}/syapi/goods/edprice`, params);
}

// 请求规格项
export function getGoodsSpecItem(params) {
	return axios.post(`${baseUrl}/syapi/goods/goodsspecitem`, params);
}
//结算接口
export function orderPay(params) {
	return axios.post(`${baseUrl}/syapi/order/settle`, params);
}

//查询扫描枪的接口
export function saomaFind(params) {
	return axios.post(`${baseUrl}/syapi/goods/scansearch`, params);
}
//轮询接口
export function getPayResult(params) {
	return axios.post(`${baseUrl}/syapi/order/query`, params);
}

//支付

export function payMoney(params) {
	return axios.post(`${baseUrl}/syapi/order/pay`, params);
}
//获取发票

export function getFaPiao(params) {
	return axios.post(`${baseUrl}/syapi/order/fapiao`, params);
}

//平单

export function handPingDan(params) {
	return axios.post(`${baseUrl}/syapi/pici/handPingDan`, params);
}

//发送验证码
export function goSendCode(params) {
	return axios.post(`${baseUrl}/syapi/sms/sendcaptcha`, params);
}
// 获取主题颜色 收款按钮背景色 主题字体颜色
export function getColorConfig() {
	return axios({
		url: `${baseUrl}/syapi/config/color`,
		method: "get"
	});
}
//获取语音
export function getAudio(params) {
	return axios.get(`${baseUrl}/syapi/config/textVoice`, params);
}
//获取第二轮播
export function getmadt(params) {
	return axios.get(`${baseUrl}/syapi/config/secondscreenad`, params);
}
//生成一维码
export function getBarcodegena(params) {
	return axios({
		url: `${baseUrl}/syapi/config/Barcodegena`,
		method: "get",
		// responseType:'blob',
		params
	});
}
// 切换商品上架状态
export function updateSaleStatus(params) {
	return axios.get(
		`${baseUrl}/syapi/goods/updateStatus?ids=${params.ids}&status=${params.status}`,
		params
	);
}
// 获取商品信息
export function getGoodsInfo(params) {
	// return axios.get(`${baseUrl}/syapi/goods/getLabel`, params)
	return axios({
		url: `${baseUrl}/syapi/goods/getLabel`,
		method: "get",
		params
	});
}
// 生成商品条形码
export function getCodeTim(params) {
	return axios({
		url: `${baseUrl}/syapi/goods/saveLabel`,
		method: "get",
		// responseType:'blob',
		params
	});
}
// 获取基本配置
export function getBaseConfig(params) {
	return axios({
		url: `${baseUrl}/syapi/config/config`,
		method: "get",
		params
	});
}
//主屏
export function speakST(val, type) {
	// 检查浏览器是否支持Web Speech API
	const synth = window.speechSynthesis;
	// 创建一个新的SpeechSynthesisUtterance对象
	let text = "";
	// 设置要转换为语音的文本
	if (type) {
		if (type == "wechat") {
			text = `微信支付，收款${val}元`;
		} else if (type == "alipay") {
			text = `支付宝支付，收款${val}元`;
		} else {
			text = `${val}`;
		}
	} else {
		text = `收款成功，收款${val}元`;
	}
	// console.log(text)
	if (window.ttsspeaker) {
		window.ttsspeaker(text);
	} else {
		const speech = new SpeechSynthesisUtterance();
		speech.text = text;
		window.speechSynthesis.speak(speech);
	}
	// // 将文本转换为声音
	// axios.get(`${baseUrl}/syapi/config/textVoice?text=${text}&spd=5`, {
	//   responseType: 'blob'
	// }).then((res) => {
	//   // console.log(res)
	//   // const blob = res
	//   // // 处理下载得到的 Blob 对象
	//   // // 创建 AudioContext 对象
	//   // // 将返回的音频数据（res）封装成一个Blob对象
	//   // const audioBlob = new Blob([res], { type: 'audio/mp3' });
	//   // // 创建audio元素
	//   // const audio = new Audio();
	//   // // const audio = document.createElement('audio'); 也可以替代上面的创建元素方法
	//   // // 通过 createObjectURL 方法将 Blob 对象生成一个音频文件 URL
	//   // audio.src = URL.createObjectURL(audioBlob);
	//   // // 在页面中播放音频
	//   // audio.play();
	//   // // 回收对象URL
	//   // URL.revokeObjectURL(audioUrl);

	//   const blob = res;
	//   const audioBlob = new Blob([blob], { type: 'audio/mp3' });
	//   // 将Blob对象转换成URL对象并设置音频元素的src属性
	//   const audioUrl = URL.createObjectURL(audioBlob);
	//   const audio = document.getElementById('myAudio');
	//   audio.src = audioUrl;
	//   // 播放音频
	//   audio.play();
	//   // URL.revokeObjectURL(audioUrl);
	// }).catch(() => {

	// })
}
export function getGurrentTime() {
	let yy = new Date().getFullYear();
	let mm =
		new Date().getMonth() + 1 < 10
			? "0" + (new Date().getMonth() + 1)
			: new Date().getMonth() + 1;
	let dd =
		new Date().getDate() < 10
			? "0" + new Date().getDate()
			: new Date().getDate();
	let hh =
		new Date().getHours() < 10
			? "0" + new Date().getHours()
			: new Date().getHours();
	let mf =
		new Date().getMinutes() < 10
			? "0" + new Date().getMinutes()
			: new Date().getMinutes();
	let ss =
		new Date().getSeconds() < 10
			? "0" + new Date().getSeconds()
			: new Date().getSeconds();
	return yy + "-" + mm + "-" + dd + " " + hh + ":" + mf + ":" + ss;
}

// 获取当班销售批次
export function getSaleDuty(data) {
	return axios({
		url: `${baseUrl}/syapi/Sale/dutyData`,
		method: "post",
		// responseType:'blob',
		data
	});
}

// 获取当班销售批次详情
export function getSaleDutyDetail(data) {
	return axios({
		url: `${baseUrl}/syapi/Sale/dutyDetailData`,
		method: "post",
		// responseType:'blob',
		data
	});
}

// // 获取班次
// export function getStatistics(data) {
//     return axios({
//         url: `${baseUrl}/syapi/Statistics/lookBookData`,
//         method: "post",
//         // responseType:'blob',
//         data
//     });
// }

// 获取去结算信息
export function getGoSettlementData(data) {
	return axios({
		url: `${baseUrl}/syapi/goods/goSettlementData`,
		method: "post",
		// responseType:'blob',
		data
	});
}

export function getGoSettlementListData(data) {
	return axios({
		url: `${baseUrl}/syapi/goods/goSettlementListData`,
		method: "post",
		// responseType:'blob',
		data
	});
}

export function getGoSettlementDetailData(data) {
	return axios({
		url: `${baseUrl}/syapi/goods/goSettlementDetailData`,
		method: "post",
		// responseType:'blob',
		data
	});
}

// 获取去结算信息
export function cancelSettlementData(data) {
	return axios({
		url: `${baseUrl}/syapi/goods/cancelSettlementData`,
		method: "post",
		// responseType:'blob',
		data
	});
}
// 销售明细
export function saleDetailListData(data) {
	return axios({
		url: `${baseUrl}/syapi/goods/saleDetailListData`,
		method: "post",
		data
	});
}

// 确认结算
export function handelSettlementData(data) {
	return axios({
		url: `${baseUrl}/syapi/goods/handelSettlementData`,
		method: "post",
		// responseType:'blob',
		data
	});
}

// 入库暂存列表
export function goodsStoreCountStagingList(data) {
	return axios({
		url: `${baseUrl}/syapi/goods/goodsStoreCountStagingList`,
		method: "post",
		// responseType:'blob',
		data
	});
}

// 入库暂存操作
export function goodsStoreCountStaging(data) {
	return axios({
		url: `${baseUrl}/syapi/goods/goodsStoreCountStaging`,
		method: "post",
		// responseType:'blob',
		data
	});
}

// 入库操作
export function goodsStoreCount(data) {
	return axios({
		url: `${baseUrl}/syapi/goods/goodsStoreCount`,
		method: "post",
		// responseType:'blob',
		data
	});
}

// 删除入库暂存
export function delGoodsStoreCountStaging(data) {
	return axios({
		url: `${baseUrl}/syapi/goods/goodsStoreCountStagingDel`,
		method: "post",
		// responseType:'blob',
		data
	});
}

// 入库暂存修改
export function goodsUpdateStaging(data) {
	return axios({
		url: `${baseUrl}/syapi/goods/goodsUpdateStaging`,
		method: "post",
		// responseType:'blob',
		data
	});
}

// 盘点暂存列表
export function goodsStoreCountPandianList(data) {
	return axios({
		url: `${baseUrl}/syapi/goods/goodsStoreCountPandianList`,
		method: "post",
		// responseType:'blob',
		data
	});
}

// 盘点暂存操作
export function goodsStoreCountPandian(data) {
	return axios({
		url: `${baseUrl}/syapi/goods/goodsStoreCountPandian`,
		method: "post",
		// responseType:'blob',
		data
	});
}

// 盘点操作
export function goodsPandian(data) {
	return axios({
		url: `${baseUrl}/syapi/goods/goodsPandian`,
		method: "post",
		// responseType:'blob',
		data
	});
}

// 删除盘点暂存
export function delGoodsStoreCountPandian(data) {
	return axios({
		url: `${baseUrl}/syapi/goods/goodsStoreCountPandianDel`,
		method: "post",
		// responseType:'blob',
		data
	});
}

// 盘点暂存修改
export function goodsUpdatePandian(data) {
	return axios({
		url: `${baseUrl}/syapi/goods/goodsUpdatePandian`,
		method: "post",
		// responseType:'blob',
		data
	});
}

// 调出暂存列表
export function goodsStoreCountOutList(data) {
	return axios({
		url: `${baseUrl}/syapi/goods/goodsStoreCountOutList`,
		method: "post",
		// responseType:'blob',
		data
	});
}

// 调出暂存操作
export function goodsStoreCountOut(data) {
	return axios({
		url: `${baseUrl}/syapi/goods/goodsStoreCountOut`,
		method: "post",
		// responseType:'blob',
		data
	});
}

// 删除调出暂存
export function delGoodsStoreCountDiaochu(data) {
	return axios({
		url: `${baseUrl}/syapi/goods/goodsStoreCountOutDel`,
		method: "post",
		// responseType:'blob',
		data
	});
}

// 调出操作
export function goodsOut(data) {
	return axios({
		url: `${baseUrl}/syapi/goods/goodsOut`,
		method: "post",
		// responseType:'blob',
		data
	});
}

// 调出暂存修改
export function goodsUpdateOut(data) {
	return axios({
		url: `${baseUrl}/syapi/goods/goodsUpdateOut`,
		method: "post",
		// responseType:'blob',
		data
	});
}

// 报损暂存列表
export function goodsStoreCountLossesList(data) {
	return axios({
		url: `${baseUrl}/syapi/goods/goodsStoreCountLossesList`,
		method: "post",
		// responseType:'blob',
		data
	});
}

// 报损暂存操作
export function goodsStoreCountLosses(data) {
	return axios({
		url: `${baseUrl}/syapi/goods/goodsStoreCountLosses`,
		method: "post",
		// responseType:'blob',
		data
	});
}
export function getDevice() {
	return navigator.userAgent.match(
		/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
	);
}

export function speak(text) {
	let flag = getDevice();
	if (flag) {
		let flag_type = flag[0] ? flag[0] : "Android";
		if (flag_type == "Android") {
			// 安卓设备
			//调取斯普瑞特打印机
			let printer_info = JSON.parse(localStorage.getItem("printer_info"));
			if (printer_info.speaker) {
				// window.Android.setSpeaker(2);//这里面的
				window.Android.speakText(
					text,
					printer_info.speaker_speed,
					printer_info.speaker_pitch,
					printer_info.speaker_volume
				); //语速 音量 语调
			}
		}
	}
}

export function activeBaiduCode() {
	let flag = getDevice();
	if (flag) {
		let flag_type = flag[0] ? flag[0] : "Android";
		if (flag_type == "Android") {
			// 安卓设备
			window.Android.activateBaidu();
		}
	}
}

export function playAudioFromAssets(item) {
	let flag = getDevice();
	if (flag) {
		let flag_type = flag[0] ? flag[0] : "Android";
		if (flag_type == "Android") {
			// 安卓设备
			let printer_info = JSON.parse(localStorage.getItem("printer_info"));
			// alert(printer_info.keyboard_speaker)
			if (printer_info.keyboard_speaker) {
				let filename = "";
				if (item == "+") {
					filename = "yunyangneural_jia.mp3";
				} else if (item == "-") {
					filename = "yunyangneural_jian.mp3";
				} else if (item == "x") {
					filename = "yunyangneural_cheng.mp3";
				} else if (item == ".") {
					filename = "yunyangneural_dian.mp3";
				} else if (item == "下一项") {
					filename = "yunyangneural_xiayixiang.mp3";
				} else if (item == "删除") {
					filename = "yunyangneural_tuiwei.mp3";
				} else {
					filename = "yunyangneural_" + item + ".mp3";
				}

				window.Android.playAudioFromAssets(filename);
			}
		}
	}
}

export function fenjian_sprt_printer(item) {
	// window.Android
	let pay_str = "";
	let userinfo = JSON.parse(localStorage.getItem("userInfo"));
	let printer_info = JSON.parse(localStorage.getItem("printer_info"));
	const num = 0;

	window.Android.pSetFont(0, 1, 1, 1, 0);
	window.Android.pSetPrinter(13, 1); //
	window.Android.pPrintText(userinfo.dangkou_name + "-配货单\n");

	window.Android.pPrintText("\n");
	window.Android.pSetFont(0, 1, 1, 0, 0);
	window.Android.pSetPrinter(13, 0); //

	window.Android.pPrintText("买家:" + item.name + "\n");

	window.Android.pSetFont(0, 0, 0, 0, 0);
	window.Android.pPrintText(
		"------------------------------------------------\n"
	);
	window.Android.pSetFont(0, 0, 1, 0, 0);
	window.Android.pPrintText("品名                 订购                 实际\n");
	window.Android.pSetFont(0, 0, 0, 0, 0);
	window.Android.pPrintText(
		"------------------------------------------------\n"
	);
	let order_detail = item.order_car;
	for (let i = 0; i < order_detail.length; i++) {
		window.Android.pSetFont(0, 0, 1, 1, 0);
		//判断字符的长度
		let len = order_detail[i].goods_name.length;
		let goods_name = i + 1 + "." + order_detail[i].goods_name;
		for (let i = 0; i < 19 - len * 2; i++) {
			goods_name = goods_name + " ";
		}
		let show_num = order_detail[i].weight
			? order_detail[i].weight
			: order_detail[i].num;
		let show_unit = order_detail[i].unit;
		if (show_unit.length == 1) {
			show_unit = order_detail[i].unit + "  ";
		}
		// if (show_unit.length == 2) {
		// 	show_unit = order_detail[i].unit + "    ";
		// }
		let goods_info = "";
		window.Android.pSetPrinter(13, 0); //

		goods_info = goods_info + goods_name;

		goods_info = goods_info + show_num + show_unit + "        ";

		window.Android.pPrintText(goods_info + "\n");

		window.Android.pSetFont(0, 0, 0, 1, 0);
		window.Android.pSetPrinter(13, 0); //

		if (order_detail[i].pici) {
			window.Android.pPrintText(
				order_detail[i].pici.huozhu_name +
					"-" +
					order_detail[i].pici.pici +
					"\n"
			);
		}

		window.Android.pSetPrinter(13, 0); //
	}

	window.Android.pSetFont(0, 0, 0, 0, 0);
	window.Android.pPrintText(
		"------------------------------------------------\n"
	);
	window.Android.pSetFont(0, 0, 1, 1, 0);

	window.Android.pPrintText("总数量:" + item.total_num + "\n");

	window.Android.pSetFont(0, 0, 0, 1, 0);
	window.Android.pPrintText(
		"打印员:" + item.user.name + " 打印时间:" + getGurrentTime() + "\n"
	);

	for (let i = 0; i < num; i++) {
		window.Android.pPrintText("\n");
	}
	window.Android.pCutPaper(65, 50);
}

//主屏
export function sprt_printer(item) {

 
	const num = 0;
	window.Android.pSetFont(0, 1, 1, 0, 0);
	window.Android.pSetPrinter(13, 0); //
	  
	 

	window.Android.pPrintText("\n");
	window.Android.pSetFont(0, 1, 1, 1, 0);
	window.Android.pSetPrinter(13, 1); //
	window.Android.pPrintText( "浅浅团购雪糕销售\n");
	window.Android.pPrintText("\n");
	window.Android.pSetFont(0, 0, 0, 0, 0);
	window.Android.pPrintText(
		"------------------------------------------------\n"
	);
	window.Android.pSetFont(0, 0, 1, 0, 0);
	
	window.Android.pPrintText("商品名称         单价       数量     总价\n");
	window.Android.pSetFont(0, 0, 0, 0, 0);
	window.Android.pPrintText(
		"------------------------------------------------\n"
	);
	 window.Android.pSetPrinter(13, 0); //
	item.forEach((detail, index) => {
		
		let msg="";
		 msg =detail.goods_name;
		 
		 
		for (let i = 0; i < 20 - (detail.goods_name.length*2); i++) {
			msg = msg + " ";
		}
		if(detail.goods_name=="总计"){
				window.Android.pSetFont(0, 0, 1, 1, 0);
				window.Android.pPrintText("\n");
				window.Android.pPrintText("\n");
				window.Android.pPrintText(msg+"             "+detail.num+"        "+detail.total_price+"\n");
		}else{
				window.Android.pSetFont(0, 0, 0, 0, 0);
				window.Android.pPrintText(msg+detail.price+"         "+detail.num+"        "+detail.total_price+"\n");
		}
		
	
		 
		// window.Android.pPrintText(detail.goods_name+detail.price +detail.num+detail.total_price+ "\n");
		
		window.Android.pSetPrinter(13, 0); //
	})

	window.Android.pSetFont(0, 0, 0, 0, 0);
	window.Android.pPrintText(
		"------------------------------------------------\n"
	);
	window.Android.pSetFont(0, 0, 1, 1, 0);
	 
	window.Android.pSetFont(0, 0, 0, 0, 0);
	 

	 
	window.Android.pSetFont(0, 0, 0, 0, 0);
	 
 
		window.Android.pPrintText("打印时间:" + getGurrentTime() + "\n");
 

	 
	 
	 
 
		window.Android.printBarCode(
			102,
			2,
			3,
			6,
			"https://u.wechat.com/EFv8ZY8c9bW5wxw-bDyYpvE",
			"gbk"
		);
		window.Android.pSetPrinter(13, 1); //
		
	 window.Android.pPrintText("扫描二维码加团长微信进群\n");
	  

	for (let i = 0; i < num; i++) {
		window.Android.pPrintText("\n");
	}
	window.Android.pCutPaper(65, 50);
 
}

export function sprt_print_jiaozhang(statisticsData) {
	let userinfo = JSON.parse(localStorage.getItem("userInfo"));
	let printer_info = JSON.parse(localStorage.getItem("printer_info"));

	window.Android.pPrintText("\n");
	window.Android.pSetFont(0, 1, 1, 1, 0);
	window.Android.pSetPrinter(13, 1); //
	window.Android.pPrintText(userinfo.dangkou_name + "收银交账单\n");

	window.Android.pPrintText("\n");
	window.Android.pSetFont(0, 0, 1, 1, 0);
	window.Android.pSetPrinter(13, 0); //
	window.Android.pPrintText(
		"收银人员:" + statisticsData.user._user.name + "\n"
	);
	window.Android.pPrintText("上次交账:" + statisticsData.start_time + "\n");
	window.Android.pPrintText("本次交账:" + statisticsData.end_time + "\n");

	window.Android.pPrintText("\n");
	window.Android.pSetFont(0, 0, 1, 0, 0);
	window.Android.pPrintText("---------------缴款金额--------------------\n");
	//循环开始
	window.Android.pSetFont(0, 0, 1, 1, 0);
	window.Android.pPrintText(
		"当班实收：" + statisticsData.shijiao_total + "元\n"
	);
	window.Android.pSetFont(0, 0, 1, 0, 0);
	if (statisticsData.cash > 0) {
		window.Android.pPrintText("现金：" + statisticsData.cash + "元\n");
	}
	if (statisticsData.wepay > 0) {
		window.Android.pPrintText("微信：" + statisticsData.wepay + "元\n");
	}
	if (statisticsData.alipay > 0) {
		window.Android.pPrintText("支付宝：" + statisticsData.alipay + "元\n");
	}
	if (statisticsData.union > 0) {
		window.Android.pPrintText("银联：" + statisticsData.union + "元\n");
	}
	if (statisticsData.other > 0) {
		window.Android.pPrintText("其他：" + statisticsData.other + "元\n");
	}

	window.Android.pPrintText("---------------账单明细--------------------\n");
	window.Android.pSetFont(0, 0, 1, 1, 0);
	//循环开始
	window.Android.pPrintText("票面总额：" + statisticsData.piaomian + "元\n");
	window.Android.pPrintText(
		"销售货款：" + statisticsData.xiaoshouhuokuan + "元\n"
	);
	window.Android.pPrintText(
		"货款零差：" + statisticsData.huokuanlingcha + "元\n"
	);
	statisticsData.data_detail_fujiafei.forEach((itemdetail, index) => {
		if (itemdetail.total > 0) {
			window.Android.pPrintText(
				itemdetail.name + "：" + itemdetail.total + "元\n"
			);
		}
	});
	if (statisticsData.youhui_total > 0) {
		window.Android.pPrintText("优惠：-" + statisticsData.youhui_total + "元\n");
	}
	if (statisticsData.duoshou_total > 0) {
		window.Android.pPrintText("多收：" + statisticsData.duoshou_total + "元\n");
	}

	window.Android.pPrintText("---------------赊还统计--------------------\n");
	//循环开始
	window.Android.pPrintText(
		"当班赊账：" + statisticsData.dangbansheqian_total + "元\n"
	);
	window.Android.pPrintText(
		"当班还款：" + statisticsData.dangbanhuankuan_total + "元\n"
	);
	window.Android.pPrintText("---------------单据统计--------------------\n");
	//循环开始
	window.Android.pPrintText(
		"订单数(按货主统计)：" +
			statisticsData.kaipiao_total_num +
			"单(" +
			statisticsData.kaipiao_total_num +
			"单)\n"
	);
	window.Android.pPrintText(
		"开票数：" + statisticsData.kaipiao_total_num + "单\n"
	);
	window.Android.pPrintText("作废定单：" + statisticsData.zuofei_num + "单\n");
	window.Android.pPrintText("修改订单：" + statisticsData.update_num + "单\n");

	window.Android.pCutPaper(66, 50);
}

export function formatLine(col1, col2, col3, col4) {
	// 设置列宽
	const col1Width = 8; // 序号/品名
	const col2Width = 5; // 销量
	const col3Width = 10; // 均价
	const col4Width = 12; // 货款

	col1 = col1.substr(0, col1Width).padEnd(col1Width, " ");

	col2 = String(col2 || "")
		.substr(0, col2Width)
		.padStart(col2Width, " ");
	col3 = String(col3 || "")
		.substr(0, col3Width)
		.padStart(col3Width, " ");
	col4 = String(col4 || "")
		.substr(0, col4Width)
		.padStart(col4Width, " ");

	return col1 + col2 + col3 + col4;
}
export function sprt_print_pici_toal(selectPici, tableData, statistics) {
	// console.log(formatLine("序号/品名", "销量", "均价", "货款"));
	// return false
	let userinfo = JSON.parse(localStorage.getItem("userInfo"));
	let printer_info = JSON.parse(localStorage.getItem("printer_info"));

	window.Android.pPrintText("\n");
	window.Android.pSetFont(0, 1, 1, 1, 0);
	window.Android.pSetPrinter(13, 1);
	window.Android.pPrintText(userinfo.dangkou_name + "批次汇总单\n");
	window.Android.pPrintText("\n");

	window.Android.pSetFont(0, 0, 0, 1, 0);
	window.Android.pSetPrinter(13, 0);
	window.Android.pPrintText(
		"货主：" + selectPici.huozhu_name + "   批次：" + selectPici.pici + "\n"
	);
	window.Android.pPrintText(
		"时间段：" + statistics.start_time + "-" + statistics.end_time + "\n"
	);
	window.Android.pSetFont(0, 0, 0, 0, 0);
	window.Android.pPrintText("---------------------------------------------\n");

	// 表头
	window.Android.pPrintText(
		formatLine("序号/品名", "销量", "均价", "货款") + "\n"
	);
	window.Android.pPrintText("---------------------------------------------\n");

	// 数据行
	tableData.forEach((detail, index) => {
		let msg = index + 1 + " " + detail.goods_name;
		for (let i = 0; i < 12 - detail.goods_name_length; i++) {
			msg = msg + " ";
		}
		msg = msg + detail.sell_str;
		for (let i = 0; i < 15 - detail.sell_str_length; i++) {
			msg = msg + " ";
		}
		msg = msg + detail.single;
		for (let i = 0; i < 10 - detail.single_length; i++) {
			msg = msg + " ";
		}

		window.Android.pPrintText(msg + detail.all_goods_price + "\n");
	});

	// 页脚
	window.Android.pSetFont(0, 0, 0, 1, 0);
	window.Android.pPrintText(
		"总件数:" +
			statistics.sell_total_num +
			"   总重量:" +
			statistics.sell_total_weight +
			"   合计:" +
			statistics.goods_total +
			"\n"
	);
	window.Android.pSetFont(0, 0, 0, 0, 0);
	window.Android.pSetFont(0, 0, 1, 1, 0);
	window.Android.pSetPrinter(13, 0);
	window.Android.pPrintText("\n");
	window.Android.pCutPaper(66, 50);
}

export function sprt_print_pici_jiesuan_toal(
	selectPici,
	moneys,
	moneyTotal,
	expenses,
	jiesuan
) {
	let userinfo = JSON.parse(localStorage.getItem("userInfo"));
	let printer_info = JSON.parse(localStorage.getItem("printer_info"));

	window.Android.pPrintText("\n");
	window.Android.pSetFont(0, 1, 1, 1, 0);
	window.Android.pSetPrinter(13, 1); //
	window.Android.pPrintText(userinfo.dangkou_name + "批次结算单\n");

	window.Android.pPrintText("\n");
	window.Android.pSetFont(0, 0, 0, 1, 0);
	window.Android.pSetPrinter(13, 0); //
	window.Android.pPrintText(
		"货主：" + selectPici.huozhu_name + "   批次：" + selectPici.pici + "\n"
	);
	window.Android.pSetFont(0, 0, 0, 0, 0);
	window.Android.pPrintText(
		"时间段：" + moneyTotal.start_time + "-" + moneyTotal.end_time + "\n"
	);

	window.Android.pPrintText("\n");
	window.Android.pSetFont(0, 0, 0, 0, 0);
	window.Android.pPrintText("---------------------------------------------\n");
	//循环开始
	window.Android.pPrintText("序号/品名     销量       均价         货款\n");

	window.Android.pPrintText("---------------------------------------------\n");

	moneys.forEach((detail, index) => {
		let msg = index + 1 + " " + detail.goods_name;
		for (let i = 0; i < 11 - detail.goods_name_length; i++) {
			msg = msg + " ";
		}
		msg = msg + detail.total_num + "(" + detail.total_weight + ")";
		for (let i = 0; i < 12 - detail.total_num_length; i++) {
			msg = msg + " ";
		}
		msg = msg + detail.single_price;
		for (let i = 0; i < 13 - detail.single_price_length; i++) {
			msg = msg + " ";
		}

		window.Android.pPrintText(msg + detail.total_goods_price + "\n");
	});

	// 	 list.forEach((itemdetail, index) => {
	// 	if(index>0){
	// 		window.Android.pPrintText(itemdetail.date+" "+itemdetail.piao_num+"         "+itemdetail.sell+"      "+itemdetail.single+"      "+itemdetail.total_price+"\n");
	// 	}

	// })

	window.Android.pPrintText(
		"总件数:" +
			moneyTotal.total_num +
			"        总重量:" +
			moneyTotal.total_weight +
			"    合计:" +
			moneyTotal.total_goods_price +
			"\n"
	);

	window.Android.pSetFont(0, 0, 0, 0, 0);

	if (expenses.length > 0) {
		window.Android.pPrintText(
			"------------------------------------------------\n"
		);
		window.Android.pPrintText("序号     费用项       金额        备注\n");
	}

	expenses.forEach((detail, index) => {
		let msg = index + 1 + "        " + detail.name;
		for (let i = 0; i < 13 - detail.name_length; i++) {
			msg = msg + " ";
		}
		let money_kongge = "";
		for (let i = 0; i < 12 - detail.money_length; i++) {
			money_kongge = money_kongge + " ";
		}

		window.Android.pPrintText(
			msg + detail.money + money_kongge + detail.notes + "\n"
		);
	});

	window.Android.pSetPrinter(13, 2); //
	if (expenses.length > 0) {
		window.Android.pPrintText("合计:" + moneyTotal.total_zhichu + "元\n");
	}

	window.Android.pSetFont(0, 0, 1, 1, 0);
	window.Android.pSetPrinter(13, 0); //
	window.Android.pPrintText(
		"------------------------------------------------\n"
	);
	window.Android.pPrintText("结算金额::" + jiesuan + "元\n");
	window.Android.pPrintText("\n");

	window.Android.pCutPaper(66, 50);
	// apis.print_history();
}

export function sprt_print_sale_detail(header, list, pici_info) {
	let userinfo = JSON.parse(localStorage.getItem("userInfo"));
	let printer_info = JSON.parse(localStorage.getItem("printer_info"));

	window.Android.pPrintText("\n");
	window.Android.pSetFont(0, 1, 1, 1, 0);
	window.Android.pSetPrinter(13, 1); //
	window.Android.pPrintText(userinfo.dangkou_name + "批次销售明细单\n");

	window.Android.pPrintText("\n");
	window.Android.pSetFont(0, 0, 0, 1, 0);
	window.Android.pSetPrinter(13, 0); //
	window.Android.pPrintText(
		"货主：" + pici_info.huozhu_name + "  批次：" + pici_info.pici + "\n"
	);
	window.Android.pSetFont(0, 0, 0, 0, 0);
	window.Android.pPrintText(
		"时间段:" + pici_info.start + "-" + pici_info.end + "\n"
	);

	window.Android.pSetFont(0, 0, 0, 0, 0);
	window.Android.pPrintText("---------------------------------------------\n");
	//循环开始
	window.Android.pPrintText("货品/时间/票号     销量     单价       货款\n");
	window.Android.pPrintText("---------------------------------------------\n");
	window.Android.pSetFont(0, 0, 0, 1, 0);

	list.forEach((itemdetail, index) => {
		if (index == 0) {
			let msg = index + 1 + " " + itemdetail.goods_name;

			for (let i = 0; i < 17 - itemdetail.goods_name_length; i++) {
				msg = msg + " ";
			}
			msg = msg + itemdetail.sell;
			for (let i = 0; i < 0 - itemdetail.sell.length; i++) {
				msg = msg + " ";
			}

			window.Android.pPrintText(
				msg +
					"   " +
					itemdetail.single +
					"      " +
					itemdetail.goods_price +
					"\n"
			);
		}
	});

	window.Android.pSetFont(0, 0, 0, 0, 0);

	list.forEach((itemdetail, index) => {
		if (index > 0) {
			let msg = itemdetail.date + " " + itemdetail.piao_num + "         ";
			msg = msg + itemdetail.sell;
			for (let i = 0; i < 11 - itemdetail.sell_length; i++) {
				msg = msg + " ";
			}
			msg = msg + itemdetail.single;
			for (let i = 0; i < 8 - itemdetail.single_length; i++) {
				msg = msg + " ";
			}

			window.Android.pPrintText(msg + "    " + itemdetail.goods_price + "\n");
		}
	});

	window.Android.pSetFont(0, 0, 0, 0, 0);
	window.Android.pPrintText(
		"------------------------------------------------\n"
	);

	window.Android.pSetFont(0, 0, 1, 1, 0);
	window.Android.pSetPrinter(13, 0); //

	window.Android.pPrintText("总销量:" + list[0].sell + "\n");
	window.Android.pPrintText("合计:" + list[0].goods_price + "元\n");
	window.Android.pPrintText("\n");

	window.Android.pCutPaper(66, 50);
	// apis.print_history();
}

export function sprt_printer_order(item) {
	let userinfo = JSON.parse(localStorage.getItem("userInfo"));
	let printer_info = JSON.parse(localStorage.getItem("printer_info"));

	window.Android.pPrintText("\n");
	window.Android.pSetFont(0, 1, 1, 1, 0);
	window.Android.pSetPrinter(13, 1); //
	window.Android.pPrintText(userinfo.dangkou_name + "-赊欠对账单\n");

	window.Android.pPrintText("\n");
	window.Android.pSetFont(0, 0, 0, 0, 0);
	window.Android.pSetPrinter(13, 0); //
	window.Android.pPrintText("买家：" + item.maijia + "\n");
	window.Android.pPrintText(
		"起止时间:" + item.start_time + "-" + item.end_time + "\n"
	);

	window.Android.pPrintText("\n");
	window.Android.pSetFont(0, 0, 0, 0, 0);
	window.Android.pPrintText("---------------------------------------------\n");
	//循环开始
	window.Android.pPrintText("日期          单号       数量       金额\n");

	window.Android.pPrintText("---------------------------------------------\n");

	item.data.forEach((itemdetail, index) => {
		if (itemdetail.changdu == 1) {
			window.Android.pPrintText(
				itemdetail.date +
					"         " +
					itemdetail.piao_num +
					"        " +
					itemdetail.num +
					"          " +
					itemdetail.total_price +
					"\n"
			);
		}
		if (itemdetail.changdu == 2) {
			window.Android.pPrintText(
				itemdetail.date +
					"         " +
					itemdetail.piao_num +
					"        " +
					itemdetail.num +
					"         " +
					itemdetail.total_price +
					"\n"
			);
		}
		if (itemdetail.changdu == 3) {
			window.Android.pPrintText(
				itemdetail.date +
					"         " +
					itemdetail.piao_num +
					"        " +
					itemdetail.num +
					"          " +
					itemdetail.total_price +
					"\n"
			);
		}
		if (itemdetail.changdu == 4) {
			window.Android.pPrintText(
				itemdetail.date +
					"         " +
					itemdetail.piao_num +
					"        " +
					itemdetail.num +
					"       " +
					itemdetail.total_price +
					"\n"
			);
		}
		if (itemdetail.changdu == 5) {
			window.Android.pPrintText(
				itemdetail.date +
					"         " +
					itemdetail.piao_num +
					"        " +
					itemdetail.num +
					"      " +
					itemdetail.total_price +
					"\n"
			);
		}
	});

	window.Android.pSetFont(0, 0, 0, 0, 0);
	window.Android.pPrintText(
		"------------------------------------------------\n"
	);

	window.Android.pSetFont(0, 0, 1, 1, 0);
	window.Android.pSetPrinter(13, 0); //

	window.Android.pPrintText("赊欠单数:" + item.num + "\n");
	window.Android.pPrintText("采购金额:" + item.total + "元\n");
	window.Android.pPrintText("已付:" + item.pay + "元\n");
	window.Android.pPrintText("赊欠:" + item.nopay + "元\n");
	window.Android.pPrintText("\n");

	window.Android.pSetFont(0, 0, 0, 0, 0);
	window.Android.pPrintText("操作人员:" + item.user._user.name + "\n");
	window.Android.pPrintText("打印时间:" + getGurrentTime() + "\n");

	window.Android.printBarCode(102, 2, 3, 6, printer_info.shoukuan_link, "gbk");
	window.Android.pSetFont(0, 0, 0, 0, 0);
	window.Android.pSetPrinter(13, 1); //
	window.Android.pPrintText("扫描方二维码查看溯源，以上食用农产品均已履\n");
	window.Android.pPrintText("行进货检查验收法定程序，索证索票齐全，销售\n");
	window.Android.pPrintText("者特此声明\n");

	window.Android.pCutPaper(66, 50);
	// apis.print_history();
}
export function sprt_printer_huankuan_order_detail(item) {
	let userinfo = JSON.parse(localStorage.getItem("userInfo"));
	let printer_info = JSON.parse(localStorage.getItem("printer_info"));

	window.Android.pPrintText("\n");
	window.Android.pSetFont(0, 1, 1, 1, 0);
	window.Android.pSetPrinter(13, 1); //
	window.Android.pPrintText(userinfo.dangkou_name + "还款凭证\n");

	window.Android.pPrintText("\n");
	window.Android.pSetFont(0, 0, 0, 0, 0);
	window.Android.pSetPrinter(13, 0); //
	window.Android.pPrintText("买家：" + item.maijia + "\n");
	window.Android.pPrintText(
		"起止时间:" + item.start_time + "-" + item.end_time + "\n"
	);

	window.Android.pPrintText("\n");
	window.Android.pSetFont(0, 0, 0, 0, 0);

	item.data.forEach((itemdetail, index) => {
		window.Android.pPrintText(
			"===============" + itemdetail.add_time + "==========\n"
		);
		//循环开始
		window.Android.pPrintText("品名           销量        单价       小计\n");

		itemdetail.order_detail.forEach((itemdetaildetail, indexdetail) => {
			let msg = indexdetail + 1 + "." + itemdetaildetail.goods_name_str;

			for (let i = 0; i < 11 - itemdetaildetail.goods_name_str.length; i++) {
				msg = msg + " ";
			}
			msg = msg + itemdetaildetail.buy;
			for (let i = 0; i < 14 - itemdetaildetail.buy_changdu; i++) {
				msg = msg + " ";
			}
			msg = msg + itemdetaildetail.price;
			for (let i = 0; i < 11 - itemdetaildetail.price_changdu; i++) {
				msg = msg + " ";
			}

			window.Android.pPrintText(msg + itemdetaildetail.total_price + "\n");
		});
		window.Android.pSetFont(0, 0, 1, 1, 0);
		window.Android.pPrintText("还款：" + itemdetail.huankuan_num + "元\n");
		window.Android.pSetFont(0, 0, 0, 0, 0);
	});
	window.Android.pPrintText(
		"======================总计======================\n"
	);

	window.Android.pSetFont(0, 0, 0, 0, 0);

	window.Android.pSetFont(0, 0, 1, 1, 0);
	window.Android.pSetPrinter(13, 0); //

	let pay_str = "";
	pay_str = pay_str + (item.cash_num > 0 ? +item.cash_num + "(现金)" : "");
	pay_str = pay_str + (item.wepay_num > 0 ? +item.wepay_num + "(微信)" : "");
	pay_str =
		pay_str + (item.alipay_num > 0 ? +item.alipay_num + "(支付宝)" : "");
	pay_str = pay_str + (item.union_num > 0 ? +item.union_num + "(银联)" : "");
	pay_str = pay_str + (item.other_num > 0 ? +item.other_num + "(其他)" : "");

	window.Android.pPrintText("还款单数:" + item.num + "\n");
	window.Android.pPrintText("本次还款:" + pay_str + "\n");
	window.Android.pPrintText("还    欠:" + item.nopay + "\n");
	window.Android.pPrintText("\n");

	window.Android.pSetFont(0, 0, 0, 0, 0);
	window.Android.pPrintText("收银员:" + item.user._user.name + "\n");
	window.Android.pPrintText("商行地址:" + userinfo.dangkou_address + "\n");

	window.Android.printBarCode(102, 2, 3, 6, printer_info.shoukuan_link, "gbk");
	window.Android.pSetFont(0, 0, 0, 0, 0);
	window.Android.pSetPrinter(13, 1); //
	window.Android.pPrintText("扫描方二维码查看溯源，以上食用农产品均已履\n");
	window.Android.pPrintText("行进货检查验收法定程序，索证索票齐全，销售\n");
	window.Android.pPrintText("者特此声明\n");

	window.Android.pCutPaper(66, 50);
	// apis.print_history();
}

export function sprt_printer_order_detail(item) {
	let userinfo = JSON.parse(localStorage.getItem("userInfo"));
	let printer_info = JSON.parse(localStorage.getItem("printer_info"));

	window.Android.pPrintText("\n");
	window.Android.pSetFont(0, 1, 1, 1, 0);
	window.Android.pSetPrinter(13, 1); //
	window.Android.pPrintText(userinfo.dangkou_name + "明细赊欠对账单\n");

	window.Android.pPrintText("\n");
	window.Android.pSetFont(0, 0, 0, 0, 0);
	window.Android.pSetPrinter(13, 0); //
	window.Android.pPrintText("买家：" + item.maijia + "\n");
	window.Android.pPrintText(
		"起止时间:" + item.start_time + "-" + item.end_time + "\n"
	);

	window.Android.pPrintText("\n");
	window.Android.pSetFont(0, 0, 0, 0, 0);

	item.data.forEach((itemdetail, index) => {
		window.Android.pPrintText(
			"===============" + itemdetail.add_time + "==========\n"
		);
		//循环开始
		window.Android.pPrintText("品名          采购量       单价       小计\n");

		itemdetail.order_detail.forEach((itemdetaildetail, indexdetail) => {
			let msg = indexdetail + 1 + "." + itemdetaildetail.goods_name_str;

			for (let i = 0; i < 10 - itemdetaildetail.goods_name_str.length; i++) {
				msg = msg + " ";
			}
			msg = msg + itemdetaildetail.buy;
			for (let i = 0; i < 14 - itemdetaildetail.buy_changdu; i++) {
				msg = msg + " ";
			}
			msg = msg + itemdetaildetail.price;
			for (let i = 0; i < 11 - itemdetaildetail.price_changdu; i++) {
				msg = msg + " ";
			}

			window.Android.pPrintText(msg + itemdetaildetail.total_price + "\n");
		});

		window.Android.pPrintText("合计：" + itemdetail.total_price + "元\n");
		window.Android.pPrintText("赊欠：" + itemdetail.sheqian + "元\n");
	});
	window.Android.pPrintText(
		"======================总计======================\n"
	);

	window.Android.pSetFont(0, 0, 0, 0, 0);

	window.Android.pSetFont(0, 0, 1, 1, 0);
	window.Android.pSetPrinter(13, 0); //

	window.Android.pPrintText("采购金额:" + item.total + "元\n");
	window.Android.pPrintText("已付:" + item.pay + "元\n");
	window.Android.pPrintText("赊欠:" + item.nopay + "元\n");
	window.Android.pPrintText("\n");

	window.Android.pSetFont(0, 0, 0, 0, 0);
	window.Android.pPrintText("操作人员:" + item.user._user.name + "\n");
	window.Android.pPrintText("打印时间:" + getGurrentTime() + "\n");

	window.Android.printBarCode(102, 2, 3, 6, printer_info.shoukuan_link, "gbk");
	window.Android.pSetFont(0, 0, 0, 0, 0);
	window.Android.pSetPrinter(13, 1); //
	window.Android.pPrintText("扫描方二维码查看溯源，以上食用农产品均已履\n");
	window.Android.pPrintText("行进货检查验收法定程序，索证索票齐全，销售\n");
	window.Android.pPrintText("者特此声明\n");

	window.Android.pCutPaper(66, 50);
	// apis.print_history();
}

export function sprt_printer2(item) {
	let userinfo = JSON.parse(localStorage.getItem("userInfo"));
	let printer_info = JSON.parse(localStorage.getItem("printer_info"));

	let pay_status = "";

	if (item.yingshou <= 0) {
		pay_status = "已付款";
	} else {
		if (item.yingshou == item.shishou) {
			pay_status = "未付款";
		} else {
			pay_status = "赊欠";
		}
	}
	if (item.status == 1) {
		pay_status = "已付款";
	}

	const num = 1;
	if (
		printer_info.field.header[0].checked &&
		!printer_info.field.header[1].checked
	) {
		window.Android.pSetFont(0, 1, 1, 0, 0);
		window.Android.pSetPrinter(13, 0); //
		window.Android.pPrintText(pay_status + "\n");
	}

	if (
		printer_info.field.header[0].checked &&
		printer_info.field.header[1].checked
	) {
		window.Android.pSetFont(0, 1, 1, 0, 0);
		window.Android.pSetPrinter(13, 0); //
		window.Android.pPrintText(
			pay_status + "              " + item.piao_num + "\n"
		);
	}

	if (
		!printer_info.field.header[0].checked &&
		printer_info.field.header[1].checked
	) {
		window.Android.pSetFont(0, 1, 1, 0, 0);
		window.Android.pSetPrinter(13, 0); //
		window.Android.pPrintText("                     " + item.piao_num + "\n");
	}
	if (printer_info.field.header[2].checked) {
		window.Android.pSetFont(0, 0, 0, 0, 0);
		window.Android.pSetPrinter(13, 2); //
		window.Android.pPrintText(item.user.name + "\n");
	}

	if (printer_info.field.header[3].checked) {
		window.Android.pPrintText("\n");
		window.Android.pSetFont(0, 0, 0, 1, 0);
		window.Android.pSetPrinter(13, 1); //
		window.Android.pPrintText(userinfo.area + "\n");
	}
	if (printer_info.field.header[4].checked) {
		window.Android.pPrintText("\n");
		window.Android.pSetFont(0, 1, 1, 1, 0);
		window.Android.pSetPrinter(13, 1); //
		window.Android.pPrintText(userinfo.dangkou_name + "-销售凭证\n");
	}
	if (printer_info.field.header[5].checked) {
		window.Android.pPrintText("\n");
		window.Android.pSetFont(0, 1, 1, 0, 0);
		window.Android.pSetPrinter(13, 0); //
		window.Android.pPrintText("买家" + item.maijia + "\n");
	}

	window.Android.pPrintText("\n");
	window.Android.pSetFont(0, 0, 0, 0, 0);
	window.Android.pPrintText("---------------------订单明细----------------\n");
	//循环开始

	item.order_detail.forEach((item, index) => {
		let header_text = "";
		let header_text1 = "";
		let fujiafei_msg = "";

		if (isFieldChecked("goods", "goods_name")) {
			header_text += index + 1 + "." + item.goods_name;
		}
		if (isFieldChecked("goods", "huozhupici")) {
			header_text +=
				"(" +
				item.order_detail_pici.huozhu_name +
				"-" +
				item.order_detail_pici.pici +
				")    ";
		}

		if (isFieldChecked("goods", "goods_total")) {
			header_text1 += "小计:" + item.total_price + "元";
		}
		let len = header_text.length; //

		let kongge_len = 32 - len;

		let kongge = "";
		for (let i = 0; i < kongge_len; i++) {
			kongge = kongge + " ";
		}

		window.Android.pSetFont(0, 0, 1, 1, 0);
		window.Android.pPrintText(header_text + kongge + header_text1 + "\n");

		window.Android.pSetFont(0, 0, 0, 0, 0);
		// window.Android.pPrintText("\n");

		let enabledGoodsFields = [];

		if (printer_info.field.goods[2].checked) {
			if (item.unit == "公斤" || item.unit == "斤") {
				enabledGoodsFields.push("重量:" + item.weight + item.unit);
				// goods_text += "数量:" + item.weight + item.unit + "      ";
			} else {
				enabledGoodsFields.push("数量:" + item.num + item.unit);
				// goods_text += "数量:" + item.num + item.unit + "      ";
			}
		}

		if (printer_info.field.goods[3].checked) {
			if (item.huozhu_num > 0) {
				enabledGoodsFields.push("单价:(包)" + item.price);
			} else {
				enabledGoodsFields.push("单价:" + item.price);
			}
		}

		if (printer_info.field.goods[4].checked) {
			// enabledGoodsFields.push(`货款:${goods_price}`);
			enabledGoodsFields.push("货款:" + item.goods_price);
		}

		item.order_detail_fujiafei.forEach(itemj => {
			printer_info.field.goods.forEach(item => {
				if (
					item.extend == "fujiafei" &&
					item.checked &&
					item.field_name == itemj.name
				) {
					fujiafei_msg =
						fujiafei_msg + item.field_name + ":" + itemj.total + "元 ";
				}
			});
		});
		item.order_detail_fujiafei.forEach(itemj => {
			printer_info.field.goods.forEach(item => {
				if (
					item.extend == "fujiafei" &&
					item.checked &&
					item.field_name == itemj.name
				) {
					enabledGoodsFields.push(`${item.field_name}:` + itemj.total + `元`);
				}
			});
		});

		const rowCount = Math.ceil(enabledGoodsFields.length / 3);

		for (let i = 0; i < rowCount; i++) {
			let line = "";

			// 获取当前行的三个位置的字段
			const leftIndex = i * 3;
			const centerIndex = i * 3 + 1;
			const rightIndex = i * 3 + 2;

			if (leftIndex < enabledGoodsFields.length) {
				line += padEnd(enabledGoodsFields[leftIndex], 10);
			} else {
				line += padEnd("", 10);
			}

			if (centerIndex < enabledGoodsFields.length) {
				line += padEnd(enabledGoodsFields[centerIndex], 12);
			} else {
				line += padEnd("", 12);
			}

			if (rightIndex < enabledGoodsFields.length) {
				line += enabledGoodsFields[rightIndex];
			}

			window.Android.pPrintText(line + "\n");
		}
	});

	window.Android.pSetFont(0, 0, 0, 0, 0);
	window.Android.pPrintText(
		"------------------------------------------------\n"
	);

	window.Android.pSetFont(0, 0, 1, 1, 0);
	window.Android.pSetPrinter(13, 0); //

	if (printer_info.field.settle[1].checked) {
		let youhui = "";
		if (item.youhui > 0) {
			youhui = "优惠:" + item.youhui + "元";
		}
		if (item.duoshou > 0) {
			youhui = "多收:" + item.duoshou + "元";
		}
		if (item.huankuan) {
			let pay_str_now = "";
			pay_str_now =
				pay_str_now +
				(item.huankuan.cash_num > 0 ? " 现金:" + item.huankuan.cash_num : "");
			pay_str_now =
				pay_str_now +
				(item.huankuan.wepay_num > 0 ? " 微信:" + item.huankuan.wepay_num : "");
			pay_str_now =
				pay_str_now +
				(item.huankuan.alipay_num > 0
					? " 支付宝:" + item.huankuan.alipay_num
					: "");
			pay_str_now =
				pay_str_now +
				(item.huankuan.union_num > 0 ? " 银联:" + item.huankuan.union_num : "");
			pay_str_now =
				pay_str_now +
				(item.huankuan.other_num > 0 ? " 其他:" + item.huankuan.other_num : "");
			window.Android.pPrintText(
				"总计:" + (item.yingshou + item.shishou) + "元\n"
			);
			window.Android.pPrintText("本次还款:" + item.huankuan.money + "\n");
			if (item.huan > item.huankuan.money) {
				window.Android.pPrintText("累计还款:" + item.huan + "\n");
			}
			window.Android.pPrintText("下欠:" + item.yingshou + "元" + "\n");
		} else {
			window.Android.pPrintText("总计:" + item.total_price + "元\n");
			if (youhui) {
				window.Android.pPrintText(youhui + "\n");
			}

			if (item.huan) {
				window.Android.pPrintText("累计还款:" + item.huan + "元\n");
			}

			if (pay_status === "赊欠") {
				window.Android.pPrintText("下欠:" + item.yingshou + "元\n");
			} else {
				window.Android.pPrintText("实收:" + item.shishou + "元\n");
			}
		}
	}

	window.Android.pSetFont(0, 0, 0, 0, 0);
	if (printer_info.field.settle[2].checked) {
		window.Android.pPrintText("备注:" + item.notes + "\n");
	}
	if (printer_info.field.settle[4].checked) {
		window.Android.pPrintText("开单时间:" + item.add_time + "\n");
	}
	if (printer_info.field.settle[3].checked && item.sheqian) {
		window.Android.pPrintText("截止到:" + getGurrentTime() + "\n");
	}
	if (printer_info.field.settle[3].checked && item.sheqian) {
		window.Android.pSetFont(0, 0, 1, 1, 0);
		window.Android.pPrintText("赊欠总额:" + item.sheqian + "元\n");
	}
	window.Android.pSetFont(0, 0, 0, 0, 0);
	if (printer_info.field.settle[5].checked) {
		window.Android.pPrintText("打印时间:" + getGurrentTime() + "\n");
	}

	let pay_str = "";
	pay_str = pay_str + (item.cash_num ? " 现金:" + item.cash_num : "");
	pay_str = pay_str + (item.wepay_num ? " 微信:" + item.wepay_num : "");
	pay_str = pay_str + (item.alipay_num ? " 支付宝:" + item.alipay_num : "");
	pay_str = pay_str + (item.union_num ? " 银联:" + item.union_num : "");
	pay_str = pay_str + (item.other_num ? " 其他:" + item.other_num : "");

	if (printer_info.field.pay[0].checked) {
		window.Android.pPrintText("支付方式:" + pay_str + "\n");
	}
	if (printer_info.field.other[0].checked) {
		window.Android.pPrintText("档口电话:" + userinfo.dangkou_phone + "\n");
	}
	if (printer_info.field.other[1].checked) {
		window.Android.pPrintText("档口地址:" + userinfo.dangkou_address + "\n");
	}
	if (printer_info.field.other[2].checked) {
		if (printer_info.shoukuan_link) {
			window.Android.printBarCode(
				102,
				2,
				3,
				6,
				printer_info.shoukuan_link,
				"gbk"
			);
			window.Android.pSetFont(0, 0, 0, 0, 0);
			window.Android.pSetPrinter(13, 1); //
			window.Android.pPrintText(
				"扫描方二维码向" + userinfo.dangkou_name + "付款"
			);
		}
	}
	for (let i = 0; i < num; i++) {
		window.Android.pPrintText("\n");
	}
	window.Android.pCutPaper(66, 50);
	apis.print_history();
}

export function sprt_printer_template() {
	let userinfo = JSON.parse(localStorage.getItem("userInfo"));
	let printer_info = JSON.parse(localStorage.getItem("printer_info"));
	// console.log(printer_info)

	let fujiafei_msg = "";

	const num = 1;

	if (printer_info.field.header[2].checked) {
		if (
			printer_info.field.header[0].checked &&
			printer_info.field.header[1].checked
		) {
			window.Android.pSetFont(0, 1, 1, 0, 0);
			window.Android.pSetPrinter(13, 0);
			window.Android.pPrintText("未付款              系统操作员A 112\n");
		} else if (
			printer_info.field.header[0].checked &&
			!printer_info.field.header[1].checked
		) {
			// 只显示状态和操作员
			window.Android.pSetFont(0, 1, 1, 0, 0);
			window.Android.pSetPrinter(13, 0);
			window.Android.pPrintText("未付款              系统操作员A\n");
		} else if (
			!printer_info.field.header[0].checked &&
			printer_info.field.header[1].checked
		) {
			// 只显示操作员和编号
			window.Android.pSetFont(0, 1, 1, 0, 0);
			window.Android.pSetPrinter(13, 0);
			window.Android.pPrintText("                    系统操作员A 112\n");
		} else {
			// 只显示操作员
			window.Android.pSetFont(0, 1, 1, 0, 0);
			window.Android.pSetPrinter(13, 0);
			window.Android.pPrintText("                    系统操作员A\n");
		}
	} else {
		if (
			printer_info.field.header[0].checked &&
			printer_info.field.header[1].checked
		) {
			window.Android.pSetFont(0, 1, 1, 0, 0);
			window.Android.pSetPrinter(13, 0); // 左对齐
			window.Android.pPrintText("未付款               112\n");
		} else if (
			printer_info.field.header[0].checked &&
			!printer_info.field.header[1].checked
		) {
			window.Android.pSetFont(0, 1, 1, 0, 0);
			window.Android.pSetPrinter(13, 0); // 左对齐
			window.Android.pPrintText("未付款\n");
		} else if (
			!printer_info.field.header[0].checked &&
			printer_info.field.header[1].checked
		) {
			window.Android.pSetFont(0, 1, 1, 0, 0);
			window.Android.pSetPrinter(13, 0); // 左对齐
			window.Android.pPrintText("                     112\n");
		}
	}

	if (printer_info.field.header[3].checked) {
		window.Android.pPrintText("\n");
		window.Android.pSetFont(0, 0, 0, 1, 0);
		window.Android.pSetPrinter(13, 1); // 居中对齐
		window.Android.pPrintText(userinfo.area + "\n");
	}
	if (printer_info.field.header[4].checked) {
		window.Android.pPrintText("\n");
		window.Android.pSetFont(0, 1, 1, 1, 0);
		window.Android.pSetPrinter(13, 1); // 居中对齐
		window.Android.pPrintText(userinfo.dangkou_name + "-销售凭证\n");
	}
	if (printer_info.field.header[5].checked) {
		window.Android.pPrintText("\n");
		window.Android.pSetFont(0, 1, 1, 0, 0);
		window.Android.pSetPrinter(13, 0); // 左对齐
		window.Android.pPrintText("买家:临时打单\n");
	}

	window.Android.pSetFont(0, 0, 0, 0, 0);
	window.Android.pPrintText(
		"------------------------------------------------\n"
	);
	window.Android.pSetFont(0, 0, 1, 0, 0);
	let header_text = "";
	header_text += "品名            ";
	header_text += "数量         ";
	header_text += "单价       ";
	header_text += "货款";
	window.Android.pPrintText(header_text + "\n");
	window.Android.pSetFont(0, 0, 0, 0, 0);
	window.Android.pPrintText(
		"------------------------------------------------\n"
	);

	window.Android.pSetFont(0, 0, 1, 1, 0);

	let goods_text = "";

	if (printer_info.field.goods[0].checked) {
		goods_text += "海南大香蕉      ";
	} else {
		goods_text += "--              ";
	}

	if (printer_info.field.goods[2].checked) {
		goods_text += "1公斤         ";
	} else {
		goods_text += "--            ";
	}

	if (printer_info.field.goods[1].checked) {
		goods_text += "8         ";
	} else {
		goods_text += "--        ";
	}

	if (printer_info.field.goods[3].checked) {
		goods_text += "8.80";
	} else {
		goods_text += "--  ";
	}

	window.Android.pPrintText(goods_text + "\n");
	window.Android.pSetFont(0, 0, 0, 1, 0);
	window.Android.pSetPrinter(13, 0); // 左对齐
	if (printer_info.field.header[5].checked) {
		window.Android.pPrintText("张三-9999\n");
	}

	// 附加费处理
	printer_info.field.goods.forEach(item => {
		if (item.extend == "fujiafei" && item.checked) {
			fujiafei_msg = fujiafei_msg + item.field_name + ":6元 ";
		}
	});

	if (fujiafei_msg) {
		window.Android.pPrintText("附加费:(" + fujiafei_msg + ")\n");
		window.Android.pSetFont(0, 0, 1, 1, 0);

		printer_info.field.goods.forEach(item => {
			if (item.extend == "goods_total" && item.checked) {
				window.Android.pSetPrinter(13, 2); // 右对齐
				window.Android.pPrintText("小计:88元\n");
			}
		});

		window.Android.pSetPrinter(13, 0); // 左对齐
	}

	// 以下是商品2和商品3，保持原有代码逻辑
	window.Android.pPrintText(goods_text + "\n");
	window.Android.pSetFont(0, 0, 0, 1, 0);
	window.Android.pSetPrinter(13, 0); // 左对齐
	if (printer_info.field.header[5].checked) {
		window.Android.pPrintText("张三-9999\n");
	}
	if (fujiafei_msg) {
		window.Android.pPrintText("附加费:(" + fujiafei_msg + ")\n");
		window.Android.pSetFont(0, 0, 1, 1, 0);
		window.Android.pSetPrinter(13, 2); // 右对齐
		window.Android.pPrintText("小计:88元\n");
		window.Android.pSetPrinter(13, 0); // 左对齐
	}

	window.Android.pPrintText(goods_text + "\n");
	window.Android.pSetFont(0, 0, 0, 1, 0);
	window.Android.pSetPrinter(13, 0); // 左对齐
	if (printer_info.field.goods[1].checked) {
		window.Android.pPrintText("张三-9999\n");
	}
	if (fujiafei_msg) {
		window.Android.pPrintText("附加费:(" + fujiafei_msg + ")\n");
		window.Android.pSetFont(0, 0, 1, 1, 0);
		window.Android.pSetPrinter(13, 2); // 右对齐
		window.Android.pPrintText("小计:88元\n");
		window.Android.pSetPrinter(13, 0); // 左对齐
	}

	window.Android.pSetFont(0, 0, 0, 0, 0);
	window.Android.pPrintText(
		"------------------------------------------------\n"
	);

	window.Android.pSetFont(0, 0, 1, 1, 0);
	window.Android.pSetPrinter(13, 0); // 左对齐

	if (printer_info.field.settle[0].checked) {
		window.Android.pPrintText("总件数:20件\n");
	}
	if (printer_info.field.settle[1].checked) {
		window.Android.pPrintText("总计:100元\n");
	}

	// 添加下欠信息 - 始终显示，保持与预览一致
	window.Android.pSetFont(0, 0, 1, 1, 0); // 保持粗体
	window.Android.pPrintText("下欠:20元\n");

	// 根据付款状态，可能显示实收金额
	// 这里假设赊欠状态下需要显示实收金额
	const payStatus = "赊欠"; // 实际使用时应该从数据中获取
	if (payStatus === "赊欠") {
		window.Android.pPrintText("实收:80元\n");
	}

	window.Android.pSetFont(0, 0, 0, 0, 0);
	if (printer_info.field.settle[2].checked) {
		window.Android.pPrintText("备注:描述文字\n");
	}
	if (printer_info.field.settle[3].checked) {
		window.Android.pPrintText("截止到" + getGurrentTime() + "\n");
	}
	if (printer_info.field.settle[3].checked) {
		window.Android.pSetFont(0, 0, 1, 1, 0);
		window.Android.pPrintText("赊欠总额:100元\n");
	}
	window.Android.pSetFont(0, 0, 0, 0, 0);
	if (printer_info.field.settle[4].checked) {
		window.Android.pPrintText("开单时间:" + getGurrentTime() + "\n");
	}
	if (printer_info.field.settle[5].checked) {
		window.Android.pPrintText("打印时间:" + getGurrentTime() + "\n");
	}
	if (printer_info.field.pay[0].checked) {
		window.Android.pPrintText("支付方式:现金100元,微信100元,支付宝100元\n");
	}
	if (printer_info.field.other[0].checked) {
		window.Android.pPrintText("档口电话:" + userinfo.dangkou_phone + "\n");
	}
	if (printer_info.field.other[1].checked) {
		window.Android.pPrintText("档口地址:" + userinfo.dangkou_address + "\n");
	}
	if (printer_info.field.other[2].checked) {
		if (printer_info.shoukuan_link) {
			window.Android.printBarCode(
				102,
				2,
				3,
				6,
				printer_info.shoukuan_link,
				"gbk"
			);
			window.Android.pSetFont(0, 0, 0, 0, 0);
			window.Android.pSetPrinter(13, 1); // 居中对齐
			window.Android.pPrintText(
				"扫描方二维码向" + userinfo.dangkou_name + "付款"
			);
		}
	}
	for (let i = 0; i < num; i++) {
		window.Android.pPrintText("\n");
	}
	window.Android.pCutPaper(66, 50);
	apis.print_history();
}

export function sprt_printer_template2() {
	let userinfo = JSON.parse(localStorage.getItem("userInfo"));
	let printer_info = JSON.parse(localStorage.getItem("printer_info"));

	if (
		printer_info.field.header[0].checked ||
		printer_info.field.header[1].checked ||
		printer_info.field.header[2].checked
	) {
		window.Android.pSetFont(0, 1, 1, 0, 0);
		window.Android.pSetPrinter(13, 0); // 左对齐

		let topLine = "";
		// 添加订单状态
		if (printer_info.field.header[0].checked) {
			topLine += "未付款";
		}

		if (
			printer_info.field.header[0].checked &&
			(printer_info.field.header[2].checked ||
				printer_info.field.header[1].checked)
		) {
			topLine = topLine.padEnd(20, " ");
		}

		// 添加系统操作员和编号
		if (printer_info.field.header[2].checked) {
			topLine += "系统操作员A";
			if (printer_info.field.header[1].checked) {
				topLine += " ";
			}
		}

		if (printer_info.field.header[1].checked) {
			topLine += "112";
		}

		window.Android.pPrintText(topLine + "\n");
	}

	if (printer_info.field.header[3].checked) {
		window.Android.pPrintText("\n");
		window.Android.pSetFont(0, 0, 0, 1, 0);
		window.Android.pSetPrinter(13, 1); // 居中
		window.Android.pPrintText(userinfo.area + "\n");
	}

	if (printer_info.field.header[4].checked) {
		window.Android.pPrintText("\n");
		window.Android.pSetFont(0, 1, 1, 1, 0);
		window.Android.pSetPrinter(13, 1); // 居中
		window.Android.pPrintText(userinfo.dangkou_name + "-销售凭证\n");
	}

	if (printer_info.field.header[5].checked) {
		window.Android.pPrintText("\n");
		window.Android.pSetFont(0, 1, 1, 0, 0);
		window.Android.pSetPrinter(13, 0); // 左对齐
		window.Android.pPrintText("买家:临时打单\n");
	}

	window.Android.pPrintText("\n");
	window.Android.pSetFont(0, 0, 0, 0, 0);
	window.Android.pPrintText("------------------订单明细----------------\n");

	// 打印3个商品明细
	for (let productIndex = 0; productIndex < 3; productIndex++) {
		let header_text = "";
		if (printer_info.field.goods[0].checked) {
			header_text += `${productIndex + 1}.海南大香蕉`;
			if (printer_info.field.goods[7].checked) {
				header_text += "(张三-999)";
			}
			header_text = padEnd(header_text, 20);
		}

		if (printer_info.field.goods[6].checked) {
			header_text += "小计:88元";
		}

		window.Android.pSetFont(0, 0, 1, 1, 0);
		window.Android.pPrintText(header_text + "\n");

		window.Android.pSetFont(0, 0, 0, 0, 0);
		window.Android.pPrintText("\n");

		let enabledGoodsFields = [];

		// 添加商品明细信息
		if (printer_info.field.goods[2].checked) {
			enabledGoodsFields.push("数量:1公斤");
			enabledGoodsFields.push("重量:1kg");
		}

		if (printer_info.field.goods[1].checked) {
			enabledGoodsFields.push("单价:8");
		}

		if (printer_info.field.goods[3].checked) {
			enabledGoodsFields.push("货款:8.8");
		}

		// 添加附加费
		printer_info.field.goods.forEach(item => {
			if (item.extend == "fujiafei" && item.checked) {
				enabledGoodsFields.push(`${item.field_name}:6元`);
			}
		});

		// 计算需要打印的行数
		const rowCount = Math.ceil(enabledGoodsFields.length / 3);

		// 打印每一行，每行最多3个字段
		for (let i = 0; i < rowCount; i++) {
			let line = "";

			// 获取当前行的三个位置的字段
			const leftIndex = i * 3;
			const centerIndex = i * 3 + 1;
			const rightIndex = i * 3 + 2;

			// 左侧字段
			if (leftIndex < enabledGoodsFields.length) {
				line += padEnd(enabledGoodsFields[leftIndex], 10);
			} else {
				line += padEnd("", 10);
			}

			// 中间字段
			if (centerIndex < enabledGoodsFields.length) {
				line += padEnd(enabledGoodsFields[centerIndex], 12);
			} else {
				line += padEnd("", 12);
			}

			// 右侧字段
			if (rightIndex < enabledGoodsFields.length) {
				line += enabledGoodsFields[rightIndex];
			}

			window.Android.pPrintText(line + "\n");
		}

		if (productIndex < 2) {
			window.Android.pSetFont(0, 0, 0, 0, 0);
			window.Android.pPrintText(
				"------------------------------------------------\n"
			);
		}
	}

	// 总计部分的分隔线
	window.Android.pSetFont(0, 0, 0, 0, 0);
	window.Android.pPrintText(
		"------------------------------------------------\n"
	);

	// 总计部分
	window.Android.pSetFont(0, 0, 1, 1, 0); // 设置为粗体
	window.Android.pSetPrinter(13, 0); // 左对齐

	if (printer_info.field.settle[0].checked) {
		window.Android.pPrintText("总件数:20件\n");
	}

	if (printer_info.field.settle[1].checked) {
		window.Android.pPrintText("总计:100元\n");
	}

	// 添加下欠信息 - 使用粗体
	window.Android.pSetFont(0, 0, 1, 1, 0);
	window.Android.pPrintText("下欠:20元\n");

	// 根据支付状态可能显示实收金额
	const payStatus = "赊欠";
	if (payStatus === "赊欠") {
		window.Android.pPrintText("实收:80元\n");
	}

	window.Android.pSetFont(0, 0, 0, 0, 0);

	// 备注信息
	if (printer_info.field.settle[2].checked) {
		window.Android.pPrintText("备注:描述文字\n");
	}

	// 赊欠相关信息
	if (printer_info.field.settle[3].checked) {
		window.Android.pPrintText("截止到:" + getGurrentTime() + "\n");
		window.Android.pSetFont(0, 0, 1, 1, 0); // 粗体
		window.Android.pPrintText("累计赊欠:888元\n");
		window.Android.pSetFont(0, 0, 0, 0, 0);
	}

	// 时间信息
	if (printer_info.field.settle[4].checked) {
		window.Android.pPrintText("开单时间:" + getGurrentTime() + "\n");
	}

	if (printer_info.field.settle[5].checked) {
		window.Android.pPrintText("打印时间:" + getGurrentTime() + "\n");
	}

	// 支付方式
	if (printer_info.field.pay[0].checked) {
		window.Android.pPrintText("支付方式:现金100元,微信100元,支付宝100元\n");
	}

	// 联系信息
	if (printer_info.field.other[0].checked) {
		window.Android.pPrintText("档口电话:" + userinfo.dangkou_phone + "\n");
	}

	if (printer_info.field.other[1].checked) {
		window.Android.pPrintText("档口地址:" + userinfo.dangkou_address + "\n");
	}

	// 二维码
	if (printer_info.field.other[2].checked) {
		if (printer_info.shoukuan_link) {
			window.Android.printBarCode(
				102,
				2,
				3,
				6,
				printer_info.shoukuan_link,
				"gbk"
			);
			window.Android.pSetFont(0, 0, 0, 0, 0);
			window.Android.pSetPrinter(13, 1); // 居中
			window.Android.pPrintText(
				"扫描方二维码向" + userinfo.dangkou_name + "付款"
			);
		}
	}

	// 走纸和切纸
	window.Android.pPrintText("\n");
	window.Android.pCutPaper(66, 50);
	apis.print_history();
}

function padEnd(str, length) {
	while (str.length < length) {
		str += " ";
	}
	return str;
}

// 删除调出暂存
export function delGoodsStoreCountLoss(data) {
	return axios({
		url: `${baseUrl}/syapi/goods/goodsStoreCountLossesDel`,
		method: "post",
		// responseType:'blob',
		data
	});
}

// 报损暂存修改
export function goodsUpdateLosses(data) {
	return axios({
		url: `${baseUrl}/syapi/goods/goodsUpdateLosses`,
		method: "post",
		// responseType:'blob',
		data
	});
}

// 调出操作
export function goodsLosses(data) {
	return axios({
		url: `${baseUrl}/syapi/goods/goodsLosses`,
		method: "post",
		// responseType:'blob',
		data
	});
}

// 生成二维码
export async function generateQRCode(data, width = 80, height = 80) {
	try {
		const options = {
			width: width,
			height: height,
			errorCorrectionLevel: "H",
			type: "image/png",
			margin: 1
		};
		const dataURL = await QRCode.toDataURL(data, options);
		return dataURL;
	} catch (error) {
		throw new Error("无法生成二维码图像: " + error.message);
	}
}

//
export async function makebase64QRCode(payQrCodeData, printDetails) {
	try {
		const base64QRCode = await generateQRCode(
			payQrCodeData ? payQrCodeData : "云批宝",
			80,
			80
		);

		printDetails.qrCodeImage = base64QRCode;
		return base64QRCode;
	} catch (error) {
		console.error("二维码生成失败:", error);
		throw new Error("二维码生成失败，无法打印");
	}
}
// 等待图片加载完成
export function waitForImagesToLoad(container) {
	return new Promise(resolve => {
		const images = container.querySelectorAll("img");
		let loadedCount = 0;

		if (images.length === 0) {
			resolve();
			return;
		}

		const checkAllImagesLoaded = () => {
			loadedCount++;
			if (loadedCount === images.length) {
				resolve();
			}
		};

		images.forEach(img => {
			if (img.complete) {
				checkAllImagesLoaded();
			} else {
				img.onload = checkAllImagesLoaded;
				img.onerror = checkAllImagesLoaded;
			}
		});
	});
}

export function isFieldChecked(key, fieldName) {
	let printer_info = JSON.parse(localStorage.getItem("printer_info"));

	let checkboxConfig = printer_info.field;
	const groupList = checkboxConfig[key];
	console.log(groupList);
	if (!groupList) {
		return false;
	}
	return groupList.some(item => item.field_name === fieldName && item.checked);
}

export function generatePrintContent1(item, transTime) {
	let printer_info = JSON.parse(localStorage.getItem("printer_info"));
	let userinfo = JSON.parse(localStorage.getItem("userInfo"));

	let html = `
    <div style="
      width: 80mm;
      padding: 10px 0px 0px 10px;
      box-sizing: border-box;
      font-size: 16px;
      line-height: 1.5;
      color: #000;
      background-color: #fff;
      margin: 0px 0px;
    ">
  `;

	let pay_status = "";
	if (item.yingshou <= 0) {
		pay_status = "已付款";
	} else {
		if (item.yingshou == item.shishou) {
			pay_status = "未付款";
		} else {
			pay_status = "赊欠";
		}
	}
	if (item.status == 1) {
		pay_status = "已付款";
	}
	if (
		printer_info.field.header[0].checked &&
		!printer_info.field.header[1].checked
	) {
		html += `
      <div style="float: left; font-weight: bold; font-size: 20px;">${pay_status}</div>
    `;
	}

	if (
		printer_info.field.header[0].checked &&
		printer_info.field.header[1].checked
	) {
		html += `
      <div style="float: left; font-weight: bold; font-size: 20px;">${pay_status}</div>
      <div style="text-align: right; font-weight: bold; font-size: 20px;">${item.piao_num}</div>
    `;
	}

	if (
		!printer_info.field.header[0].checked &&
		printer_info.field.header[1].checked
	) {
		html += `
      <div style="text-align: right; font-weight: bold; font-size: 20px;">${item.piao_num}</div>
    `;
	}

	if (isFieldChecked("header", "cashier_id")) {
		html += `
      <div style="text-align: right; font-size: 16px; margin-top: 10px;">${item.user.name}</div>
    `;
	}

	if (isFieldChecked("header", "deal_address")) {
		html += `
      <div style="text-align: center; font-size: 14px; margin-top: 10px;">
        ${userinfo.area}
      </div>
    `;
	}

	if (isFieldChecked("header", "voucher")) {
		html += `
      <div style="text-align: center; font-weight: bold; font-size: 20px; margin-top: 10px;">
        ${userinfo.dangkou_name}-销售凭证
      </div>
    `;
	}

	if (isFieldChecked("header", "maijia")) {
		html += `
      <div style="font-weight: bold; font-size: 20px; margin-top: 10px;">
        买家:${item.maijia}
      </div>
    `;
	}

	html += `
    <div style="border-top: 1px dashed #000; margin: 10px -10px;">

		</div>
  `;

	html += `
    <div style="display: flex; justify-content: space-between; font-weight: bold; margin-bottom: 5px;">
      <div style="width: 30%;">品名</div>
      <div style="width: 23%;">数量</div>
      <div style="width: 23%;">单价</div>
      <div style="width: 23%;">货款</div>
    </div>
  `;

	html += `
    <div style="border-top: 1px dashed #000; margin: 5px -10px;">

		</div>
  `;
	let order_detail = item.order_detail;

	for (let i = 0; i < order_detail.length; i++) {
		let show_num = order_detail[i].weight
			? order_detail[i].weight
			: order_detail[i].num;
		let show_unit = order_detail[i].unit;
		let price = "";

		if (order_detail[i].huozhu_num) {
			price = "(包)" + order_detail[i].price;
		} else {
			price = order_detail[i].price;
		}

		html += `
       <div style="display: flex; justify-content: space-between; margin-bottom: 10px; font-weight: bold;">`;
		if (isFieldChecked("goods", "goods_name")) {
			html += ` <div style="width: 30%;">${i + 1}.${
				order_detail[i].goods_name
			}</div>`;
		} else {
			html += ` <div style="width: 30%;">${"--"}</div>`;
		}
		if (isFieldChecked("goods", "goods_shuliang")) {
			html += ` <div style="width: 23%;">${show_num}${show_unit}</div>`;
		} else {
			html += ` <div style="width: 30%;">${"--"}</div>`;
		}
		if (isFieldChecked("goods", "goods_danjia")) {
			html += `<div style="width: 23%;">${price}</div>`;
		} else {
			html += ` <div style="width: 30%;">${"--"}</div>`;
		}
		if (isFieldChecked("goods", "goods_jiage")) {
			html += `<div style="width: 23%;">${order_detail[i].goods_price}</div>`;
		} else {
			html += ` <div style="width: 30%;">${"--"}</div>`;
		}

		html += ` </div>`;

		if (isFieldChecked("goods", "huozhupici")) {
			if (order_detail[i].order_detail_pici) {
				html += `
						  <div style="font-size: 12px; margin-bottom: 5px;">${order_detail[i].order_detail_pici.huozhu_name}--${order_detail[i].order_detail_pici.pici}</div>
						`;
			}
		}
		let order_detail_fujiafei = order_detail[i].order_detail_fujiafei;
		let str = "";
		for (let j = 0; j < order_detail_fujiafei.length; j++) {
			if (order_detail_fujiafei[j].total) {
				printer_info.field.goods.forEach(item => {
					if (
						item.extend == "fujiafei" &&
						item.checked &&
						item.field_name == order_detail_fujiafei[j].name
					) {
						str =
							str +
							order_detail_fujiafei[j].name +
							":" +
							order_detail_fujiafei[j].total +
							"元 ";
					}
				});
			}
		}

		if (str) {
			html += `
        <div style="margin-bottom: 5px;font-size:12px">附加费:(${str})</div>
      `;
		}

		if (isFieldChecked("goods", "goods_total")) {
			html += `
		     <div style="text-align: right; font-weight: bold; margin-bottom: 10px;">小计:${order_detail[i].total_price}元</div>
		  `;
		}
	}
	let youhui = "";
	if (item.youhui > 0) {
		youhui = "优惠:" + item.youhui + "元";
	}
	if (item.duoshou > 0) {
		youhui = "多收:" + item.duoshou + "元";
	}

	html += `
    <div style="border-top: 1px dashed #000; margin: 10px -10px;"></div>
  `;

	if (printer_info.field.settle[1].checked) {
		html += `
      <div style="font-weight: bold; font-size: 18px; margin-top: 5px;">总计:${item.total_price}元</div>
    `;
	}
	if (youhui) {
		html += `
	  <div style="font-weight: bold; font-size: 18px; margin-top: 5px;">${youhui}</div>
	`;
	}

	if (printer_info.field.settle[2].checked && item.notes) {
		html += `
      <div style="margin-top: 5px;">备注:${item.notes}</div>
    `;
	}

	if (printer_info.field.settle[3].checked) {
		const currentTime = transTime
			? transTime(new Date().getTime())
			: new Date().toLocaleString();
		html += `
      <div style="margin-top: 5px;">截止到${currentTime}</div>
      <div style="font-weight: bold; font-size: 18px; margin-top: 5px;">赊欠总额:${item.sheqian}元</div>
    `;
	}

	if (printer_info.field.settle[4].checked) {
		const currentTime = transTime
			? transTime(new Date().getTime())
			: new Date().toLocaleString();
		html += `
      <div style="margin-top: 5px;">开单时间:${item.add_time}</div>
    `;
	}

	if (printer_info.field.settle[5].checked) {
		const currentTime = transTime
			? transTime(new Date().getTime())
			: new Date().toLocaleString();
		html += `
      <div style="margin-top: 5px;">打印时间:${currentTime}</div>
    `;
	}
	let pay_str = "";
	pay_str = pay_str + (item.cash_num ? " 现金:" + item.cash_num : "");
	pay_str = pay_str + (item.wepay_num ? " 微信:" + item.wepay_num : "");
	pay_str = pay_str + (item.alipay_num ? " 支付宝:" + item.alipay_num : "");
	pay_str = pay_str + (item.union_num ? " 银联:" + item.union_num : "");
	pay_str = pay_str + (item.other_num ? " 其他:" + item.other_num : "");
	if (printer_info.field.pay[0].checked && pay_str) {
		html += `
      <div style="margin-top: 5px;">支付方式:${pay_str}</div>
    `;
	}

	if (printer_info.field.other[0].checked) {
		html += `
      <div style="margin-top: 5px;">档口电话:${userinfo.dangkou_phone}</div>
    `;
	}

	if (printer_info.field.other[1].checked) {
		html += `
      <div style="margin-top: 5px;">档口地址:${userinfo.dangkou_address}</div>
    `;
	}

	if (printer_info.field.other[2].checked && printer_info.shoukuan_link) {
		html += `
      <div style="text-align: center; margin: 15px 0;">
        <img src="${item.qrCodeImage}" alt="支付二维码" style="width: 150px; height: 150px;" />
        <div style="margin-top: 5px;">扫描方二维码向${userinfo.dangkou_name}付款</div>
      </div>
    `;
	}

	html += `
	<div style="display: flex; align-items: center; margin-top: 15px; padding-right: 4px;">
		<div style="flex: 0 0 auto; margin-right: 8px;">
			<img src="../../static/logo.jpeg" alt="云批宝" style="width: 50px; height: 50px;" />
		</div>
		<div style="width: 2px; background-color: rgb(72, 208, 102); height: 50px; margin-right: 4px;"></div>
		<div style="flex: 1;">
			<div style="color: rgb(72, 208, 102); font-size: 16px;">云批宝，专业农批收银管理系统</div>
			<div style="color: rgb(254, 159, 76); font-size: 13px; margin-top: 3px;">免费试用欢迎咨询电话: 400-765-6785</div>
		</div>
	</div>
	`;

	html += `</div>`;

	return html;
}

export function generatePrintContent1_(
	details,
	transTime,
	print_huozhu_chaifen = 0
) {
	let printer_info = JSON.parse(localStorage.getItem("printer_info"));
	let userinfo = JSON.parse(localStorage.getItem("userInfo"));

	let html = `
	<div style="
		width: 80mm;
		padding: 10px 0px 0px 10px;
		box-sizing: border-box;
		font-size: 16px;
		line-height: 1.5;
		color: #000;
		background-color: #fff;
		margin: 0px 0px;
	">
`;

	let pay_status = "";
	if (details.yingshou <= 0) {
		pay_status = "已付款";
	} else {
		if (details.yingshou == details.shishou) {
			pay_status = "未付款";
		} else {
			pay_status = "赊欠";
		}
	}
	if (details.status == 1) {
		pay_status = "已付款";
	}

	if (isFieldChecked("header", "order_status")) {
		html += `
		<div data-v-25fecb1b="" style="float: left; font-weight: bold; font-size: 20px;">${pay_status}</div>
	`;
	}

	html += ` <div style="text-align: right; margin-bottom: 4px; font-weight: bold; margin-bottom: 20px; font-size: 20px;"> `;
	if (isFieldChecked("header", "cashier_id")) {
		html += `${details.user.name || "系统操作员A"} `;
	}

	if (isFieldChecked("header", "piao_num")) {
		html += `${details.piao_num || "009"} `;
	}

	html += `</div>`;

	if (isFieldChecked("header", "deal_address")) {
		html += `
		<div style="text-align: center; font-size: 14px;">
			${userinfo.area}
		</div>
	`;
	}
	if (isFieldChecked("header", "voucher")) {
		html += `
		<div style="text-align: center; font-weight: bold; font-size: 20px; margin-bottom: 4px;">
			${userinfo.dangkou_name}-销售凭证
		</div>
	`;
	}
	if (isFieldChecked("header", "maijia")) {
		html += `
		<div style="margin-bottom: 2px; font-weight: bold; font-size: 20px;">
			买家:${details.maijia || "临时买家"}
		</div>
	`;
	}

	// 商品列表标题
	html += `
	<div style="display: flex; justify-content: space-between; border-bottom: 1px dashed #000; margin-bottom: 5px; font-weight: bold;">
		<div>品名</div>
		<div>数量</div>
		<div>单价</div>
		<div>货款</div>
	</div>
	`;

	details.order_detail.forEach((product, index) => {
		html += `
		<div style="font-weight: bold; margin-bottom: 5px;">
			${index + 1}.${
			isFieldChecked("goods", "goods_name")
				? product.goods_name || "海南大香蕉"
				: "--"
		}
		</div>
		`;

		// 商品信息
		html += `
		<div style="display: flex; justify-content: space-between; margin-bottom: 5px; font-weight: bold;">
			<div>
				${
					isFieldChecked("goods", "goods_shuliang")
						? `${product.num || "1"}${product.unit || "公斤"}`
						: "--"
				}
			</div>
			<div>
				${isFieldChecked("goods", "goods_danjia") ? product.price || "8" : "--"}
			</div>
			<div>
				${isFieldChecked("goods", "goods_jiage") ? product.goods_price || "8.80" : "--"}
			</div>
		</div>
		`;

		// 货主批次
		if (isFieldChecked("goods", "huozhupici")) {
			if (product.order_detail_pici) {
				html += `
				<div style="margin-bottom: 5px;">
					${product.order_detail_pici.huozhu.name || "张三"}-${product.order_detail_pici
					.pici || "9999"}
				</div>
				`;
			}
		}

		// 附加费
		html += `<div style="margin-bottom: 5px;">`;
		if (product.order_detail_fujiafei == "测试") {
			printer_info.field.goods.forEach(item => {
				if (item.extend == "fujiafei" && item.checked) {
					html += `<span>附加费: (${item.field_name}:6元)</span> `;
				}
			});
		} else if (product.order_detail_fujiafei) {
			html += `<span>附加费: (`;
			product.order_detail_fujiafei.forEach((itemj, idx) => {
				printer_info.field.goods.forEach(item => {
					if (
						item.extend == "fujiafei" &&
						item.checked &&
						item.field_name == itemj.name
					) {
						html += `${item.field_name}:${itemj.total}元${
							idx < product.order_detail_fujiafei.length - 1 ? ", " : ""
						}`;
					}
				});
			});
			html += `)</span>`;
		}
		html += `</div>`;

		// 小计
		if (isFieldChecked("goods", "goods_total")) {
			html += `
			<div style="text-align: right; font-weight: bold; margin-bottom: 5px;">
				小计:${product.total_price || "88"}元
			</div>
			`;
		}
	});

	html += `<hr style="border-top: 1px dashed #000; margin: 10px 0;" />`;

	// 总件数
	if (isFieldChecked("goods", "goods_num")) {
		html += `
		<div style="font-weight: bold; font-size: 18px;">总件数:${details.order_detail
			.length || "3"}件</div>
		`;
	}

	// 总金额
	if (isFieldChecked("settle", "total_price")) {
		let youhui = "";
		if (details.youhui > 0) {
			youhui = " 优惠:" + details.youhui + "元";
		}
		if (details.duoshou > 0) {
			youhui = "多收:" + details.duoshou + "元";
		}

		if (details.huankuan) {
			html += `
				<div style="font-weight: bold; font-size: 18px;">总计:${details.yingshou +
					details.shishou}元</div>
			`;
			html += `
				<div style="font-weight: bold; font-size: 18px;">本次还款:${details.huankuan.money}元</div>
			`;
			if (details.huan > details.huankuan.money) {
				html += `<div style="font-weight: bold; font-size: 18px;">累计还款:${details.huan}元</div>`;
			}
			// 确保始终显示下欠
			html += `
				<div style="font-weight: bold; font-size: 18px;">下欠:${details.yingshou}元</div>
			`;
		} else {
			html += `
				<div style="font-weight: bold; font-size: 18px;">总计:${details.total_price ||
					"8"}元</div>
			`;
			if (youhui) {
				html += `
					<div style="font-weight: bold; font-size: 18px;">${youhui}</div>
				`;
			}
			if (details.huan) {
				html += `
					<div style="font-weight: bold; font-size: 18px;">累计还款:${details.huan}元</div>
				`;
			}

			html += `
				<div style="font-weight: bold; font-size: 18px;">下欠:${details.yingshou ||
					"0"}元</div>
			`;

			if (print_huozhu_chaifen == 1 && pay_status !== "赊欠") {
				html += `
					<div style="font-weight: bold; font-size: 18px;">实收:${details.shishou ||
						"8"}元</div>
				`;
			}
		}
	}

	// 支付方式信息
	let pay_str = "";
	pay_str = pay_str + (details.cash_num ? " 现金:" + details.cash_num : "");
	pay_str = pay_str + (details.wepay_num ? " 微信:" + details.wepay_num : "");
	pay_str =
		pay_str + (details.alipay_num ? " 支付宝:" + details.alipay_num : "");
	pay_str = pay_str + (details.union_num ? " 银联:" + details.union_num : "");
	pay_str = pay_str + (details.other_num ? " 其他:" + details.other_num : "");

	if (isFieldChecked("pay", "zhifufangshi") && pay_str) {
		html += `
		<div style="margin-bottom: 4px;">支付方式:${pay_str}</div>
		`;
	}

	// 二维码
	if (isFieldChecked("other", "pay_qr_code")) {
		html += `
		<div style="text-align: center; margin: 10px 0;">
			<img src="${details.qrCodeImage}" alt="二维码" style="width: 150px; height: 150px;" />
			<br />
			<div>扫描上方二维码向${userinfo.dangkou_name}配送付款</div>
		</div>
		`;
	}

	// 备注信息
	if (isFieldChecked("settle", "notes")) {
		html += `
		<div style="margin-bottom: 4px;">备注:${details.notes || "备注信息"}</div>
		`;
	}

	// 赊欠信息
	if (isFieldChecked("settle", "sheqian") && details.sheqian > 0) {
		html += `
		<div style="margin-bottom: 4px;">
			截止到:${transTime(new Date().getTime())}
			<br />
			<span style="font-weight:bold;font-size:18px">累计赊欠:${details.sheqian ||
				"888"}元</span>
		</div>
		`;
	}

	// 时间信息
	if (isFieldChecked("settle", "add_time")) {
		html += `
		<div style="margin-bottom: 4px;">开单时间:${details.add_time ||
			"2025-3-3 11:30:30"}</div>
		`;
	}

	if (isFieldChecked("settle", "print_time")) {
		html += `
		<div style="margin-bottom: 4px;">打印时间:${transTime(
			new Date().getTime()
		)}</div>
		`;
	}

	// 联系信息
	if (isFieldChecked("other", "mobile") && userinfo.dangkou_phone) {
		html += `
		<div style="margin-bottom: 4px;">档口电话:${userinfo.dangkou_phone ||
			"17720498851"}</div>
		`;
	}

	if (isFieldChecked("other", "address") && userinfo.dangkou_address) {
		html += `
		<div style="margin-bottom: 4px;">档口地址:${userinfo.dangkou_address}</div>
		`;
	}

	// 免责声明
	html += `
	<div style="margin-top: 10px;">${details.disclaimer ||
		"以上食用农产品均履行进货检查法定程序索证索票齐全销售者特此声明。"}</div>
	`;

	html += `</div>`;

	return html;
}

export function generatePrintContent2(item, transTime) {
	let printer_info = JSON.parse(localStorage.getItem("printer_info"));
	let userinfo = JSON.parse(localStorage.getItem("userInfo"));

	let html = `
    <div style="
      width: 80mm;
       padding: 10px 0px 0px 10px;
      box-sizing: border-box;
      font-size: 16px;
      line-height: 1.5;
      color: #000;
      background-color: #fff;
      margin: 0px 0px;
    ">
  `;
	let pay_status = "";

	if (item.yingshou <= 0) {
		pay_status = "已付款";
	} else {
		if (item.yingshou == item.shishou) {
			pay_status = "未付款";
		} else {
			pay_status = "赊欠";
		}
	}
	if (item.status == 1) {
		pay_status = "已付款";
	}

	if (
		printer_info.field.header[0].checked &&
		!printer_info.field.header[1].checked
	) {
		html += `
      <div style="float: left; font-weight: bold; font-size: 20px;">${pay_status}</div>
    `;
	}

	if (
		printer_info.field.header[0].checked &&
		printer_info.field.header[1].checked
	) {
		html += `
      <div style="float: left; font-weight: bold; font-size: 20px;">${pay_status}</div>
      <div style="text-align: right; font-weight: bold; font-size: 20px;">${item.piao_num}</div>
    `;
	}

	if (
		!printer_info.field.header[0].checked &&
		printer_info.field.header[1].checked
	) {
		html += `
      <div style="text-align: right; font-weight: bold; font-size: 20px;">${item.piao_num}</div>
    `;
	}

	if (printer_info.field.header[2].checked) {
		html += `
      <div style="text-align: right; font-size: 16px; margin-top: 10px;">${item.user.name}</div>
    `;
	}

	if (printer_info.field.header[3].checked) {
		html += `
      <div style="text-align: center; font-size: 14px; margin-top: 10px;">
        ${userinfo.area}
      </div>
    `;
	}

	if (printer_info.field.header[4].checked) {
		html += `
      <div style="text-align: center; font-weight: bold; font-size: 20px; margin-top: 10px;">
        ${userinfo.dangkou_name}-销售凭证
      </div>
    `;
	}

	if (printer_info.field.header[5].checked) {
		html += `
      <div style="font-weight: bold; font-size: 20px; margin-top: 10px;">
        买家:${item.maijia}
      </div>
    `;
	}

	html += `
    <div style=" font-size: 18px; text-align: center; margin: 15px 0 10px 0;">
      -------------订单明细---------------
    </div>
  `;

	item.order_detail.forEach((item_detail, index) => {
		let headerText = "";
		if (isFieldChecked("goods", "goods_name")) {
			headerText += index + 1 + "." + item_detail.goods_name;
		}
		if (isFieldChecked("goods", "huozhupici")) {
			if (item_detail.order_detail_pici) {
				var huozhuName = "";
				if (
					item_detail.order_detail_pici.huozhu_name !== undefined &&
					item_detail.order_detail_pici.huozhu_name !== null
				) {
					huozhuName = item_detail.order_detail_pici.huozhu_name;
				}

				var piciValue = "";
				if (
					item_detail.order_detail_pici.pici !== undefined &&
					item_detail.order_detail_pici.pici !== null
				) {
					piciValue = item_detail.order_detail_pici.pici;
				}

				headerText += "(" + huozhuName + "-" + piciValue + ")";
			}
		}
		if (isFieldChecked("goods", "goods_total")) {
			headerText += "小计:" + item_detail.goods_price + "元       ";
		}

		if (headerText) {
			html += `
      <div style="font-weight: bold; margin-bottom: 10px;">
        ${headerText}
      </div>
    `;
		}

		let enabledGoodsFields = [];

		if (isFieldChecked("goods", "goods_shuliang")) {
			if (item.unit == "公斤" || item.unit == "斤") {
				enabledGoodsFields.push(
					"重量:" + item_detail.weight + item_detail.unit
				);
			} else {
				enabledGoodsFields.push("数量:" + item_detail.num + item_detail.unit);
			}
		}

		if (printer_info.field.goods[3].checked) {
			if (item_detail.huozhu_num > 0) {
				enabledGoodsFields.push("单价:(包)" + item_detail.price);
			} else {
				enabledGoodsFields.push("单价:" + item_detail.price);
			}
		}

		if (printer_info.field.goods[4].checked) {
			enabledGoodsFields.push("货款:" + item_detail.goods_price);
		}
		console.log("item_detail", item_detail);
		if (item_detail.order_detail_fujiafei instanceof Array) {
			item_detail.order_detail_fujiafei.forEach(itemj => {
				printer_info.field.goods.forEach(item => {
					if (
						item.extend == "fujiafei" &&
						item.checked &&
						item.field_name == itemj.name
					) {
						enabledGoodsFields.push(`${item.field_name}:` + itemj.total + `元`);
					}
				});
			});
		}
		const padEnd = (str, length) => {
			if (str.length >= length) return str;
			return str + " ".repeat(length - str.length);
		};

		if (enabledGoodsFields.length > 0) {
			const rowCount = Math.ceil(enabledGoodsFields.length / 3);

			for (let i = 0; i < rowCount; i++) {
				let line = "";

				const leftIndex = i * 3;
				const centerIndex = i * 3 + 1;
				const rightIndex = i * 3 + 2;

				if (leftIndex < enabledGoodsFields.length) {
					line += padEnd(enabledGoodsFields[leftIndex], 10);
				} else {
					line += padEnd("", 10);
				}

				if (centerIndex < enabledGoodsFields.length) {
					line += padEnd(enabledGoodsFields[centerIndex], 12);
				} else {
					line += padEnd("", 12);
				}

				if (rightIndex < enabledGoodsFields.length) {
					line += enabledGoodsFields[rightIndex];
				}

				html += `<div style="margin-bottom: 5px;">${line}</div>`;
			}
		}
	});

	let youhui = "";
	if (item.youhui > 0) {
		youhui = "优惠:" + item.youhui + "元";
	}
	if (item.duoshou > 0) {
		youhui = "多收:" + item.duoshou + "元";
	}

	html += `
    <div style="border-top: 1px dashed #000; margin: 15px -10px 10px -10px;"></div>
  `;

	if (printer_info.field.settle[1].checked) {
		html += `
      <div style="font-weight: bold; font-size: 18px; margin-top: 5px;">总计:${item.total_price}元</div>
    `;
	}
	if (youhui) {
		html += `
	    <div style="font-weight: bold; font-size: 18px; margin-top: 5px;">${youhui}</div>
	  `;
	}

	if (printer_info.field.settle[2].checked && item.notes) {
		html += `
      <div style="margin-top: 5px;">备注:${item.notes}</div>
    `;
	}
	console.log("item", item);
	if (printer_info.field.settle[3].checked && item.sheqian) {
		const currentTime = transTime
			? transTime(new Date().getTime())
			: new Date().toLocaleString();
		html += `
      <div style="margin-top: 5px;">开单时间:${item.creditDate}</div>
      <div style="margin-top: 5px;">截止到:${currentTime}</div>
      <div style="font-weight: bold; font-size: 18px; margin-top: 5px;">赊欠总额:${item.sheqian}元</div>
    `;
	}

	if (printer_info.field.settle[4].checked) {
		const currentTime = transTime
			? transTime(new Date().getTime())
			: new Date().toLocaleString();
		html += `
      <div style="margin-top: 5px;">打印时间:${currentTime}</div>
    `;
	}
	let pay_str = "";
	pay_str = pay_str + (item.cash_num ? " 现金:" + item.cash_num : "");
	pay_str = pay_str + (item.wepay_num ? " 微信:" + item.wepay_num : "");
	pay_str = pay_str + (item.alipay_num ? " 支付宝:" + item.alipay_num : "");
	pay_str = pay_str + (item.union_num ? " 银联:" + item.union_num : "");
	pay_str = pay_str + (item.other_num ? " 其他:" + item.other_num : "");

	if (printer_info.field.pay[0].checked && pay_str) {
		html += `
      <div style="margin-top: 5px;">支付方式:${pay_str}</div>
    `;
	}

	if (printer_info.field.other[0].checked) {
		html += `
      <div style="margin-top: 5px;">档口电话:${userinfo.dangkou_phone}</div>
    `;
	}

	if (printer_info.field.other[1].checked) {
		html += `
      <div style="margin-top: 5px;">档口地址:${userinfo.dangkou_address}</div>
    `;
	}

	if (printer_info.field.other[2].checked && printer_info.shoukuan_link) {
		html += `
      <div style="text-align: center; margin: 15px 0;">
        <img src="${item.qrCodeImage}" alt="支付二维码" style="width: 150px; height: 150px;" />
        <div style="margin-top: 5px;">扫描方二维码向${userinfo.dangkou_name}付款</div>
      </div>
    `;
	}

	if (printer_info.field.other[1].checked) {
		html += `
		<div style="display: flex; align-items: center; margin-top: 15px; padding-right: 4px;">
			<div style="flex: 0 0 auto; margin-right: 8px;">
					<img src="../../static/logo.jpeg" alt="云批宝" style="width: 50px; height: 50px;" />
			</div>
			<div style="width: 2px; background-color: rgb(72, 208, 102); height: 50px; margin-right: 4px;"></div>
			<div style="flex: 1;">
				<div style="color: rgb(72, 208, 102); font-size: 16px;">云批宝，专业农批收银管理系统</div>
				<div style="color: rgb(254, 159, 76); font-size: 13px; margin-top: 3px;">免费试用欢迎咨询电话: 400-765-6785</div>
			</div>
		</div>
		`;
	}

	html += `
	</div>
	`;

	return html;
}

//

export function generatePrintContent3(
	details,
	transTime,
	print_huozhu_chaifen = 0
) {
	let printer_info = JSON.parse(localStorage.getItem("printer_info"));
	let userinfo = JSON.parse(localStorage.getItem("userInfo"));

	let html = `
	<div style="
		width: 80mm;
		 padding: 10px 0px 0px 10px;
		box-sizing: border-box;
		font-size: 16px;
		line-height: 1.5;
		color: #000;
		background-color: #fff;
		margin: 0px 0px;
	">
`;

	let pay_status = "";
	if (details.yingshou <= 0) {
		pay_status = "已付款";
	} else {
		if (details.yingshou == details.shishou) {
			pay_status = "未付款";
		} else {
			pay_status = "赊欠";
		}
	}
	if (details.status == 1) {
		pay_status = "已付款";
	}

	if (isFieldChecked("header", "order_status")) {
		html += `
		<div data-v-25fecb1b="" style="float: left; font-weight: bold; font-size: 20px;">${pay_status}</div>
	`;
	}
	html += ` <div style="text-align: right; margin-bottom: 4px; font-weight: bold; margin-bottom: 20px; font-size: 20px;"> `;
	if (isFieldChecked("header", "cashier_id")) {
		html += `${details.user.name || "系统操作员A"} `;
	}

	if (isFieldChecked("header", "piao_num")) {
		html += `${details.piao_num || "009"} `;
	}

	html += `</div>`;

	if (isFieldChecked("header", "deal_address")) {
		html += `
		<div style="text-align: center; font-size: 14px;">
			${userinfo.area}
		</div>
	`;
	}
	if (isFieldChecked("header", "voucher")) {
		html += `
		<div style="text-align: center; font-weight: bold; font-size: 20px; margin-bottom: 4px;">
			${userinfo.dangkou_name}-销售凭证
		</div>
	`;
	}
	if (isFieldChecked("header", "maijia")) {
		html += `
		<div style="margin-bottom: 2px; font-weight: bold; font-size: 20px;">
			买家:${details.maijia || "临时买家"}
		</div>
	`;
	}

	details.order_detail.forEach((product, index) => {
		let productLeft = "";
		let productRight = "";

		if (isFieldChecked("goods", "goods_name")) {
			productLeft = `${index + 1}.${product.goods_name || "海南大香蕉"}`;
		}
		// console.log("product.order.detail.pici",product.order_detail_pici)
		if (isFieldChecked("goods", "huozhupici")) {
			if (product.order_detail_pici) {
				var huozhuName = "张三";
				if (
					product.order_detail_pici.huozhu_name !== undefined &&
					product.order_detail_pici.huozhu_name !== null
				) {
					huozhuName = product.order_detail_pici.huozhu_name;
				}

				var piciDisplay = "-999";
				if (
					product.order_detail_pici.pici !== undefined &&
					product.order_detail_pici.pici !== null
				) {
					piciDisplay = -product.order_detail_pici.pici;
				}

				productLeft = productLeft + `  ${huozhuName}${piciDisplay}`;
			}
		}

		if (isFieldChecked("goods", "goods_total")) {
			productRight = `小计:${product.total_price || "8.8"}元`;
		}

		if (productLeft || productRight) {
			html += `
			<div style="display: flex; justify-content: space-between; margin-bottom: 5px; font-weight: bold;">
				<div>${productLeft}</div>
				<div>${productRight}</div>
			</div>
		`;
		}

		html += `
		<table border="1" style="width: 100%; border-collapse: collapse; margin-bottom: 5px; border: 0.6px solid black; font-size: 16px;">
			<tr>
				<th style="margin-bottom: 0px; font-size: 16px; line-height: 1.6; border: 0.6px solid black;">件数</th>
				<th style="margin-bottom: 0px; font-size: 16px; line-height: 1.6; border: 0.6px solid black;">重量</th>
				<th style="margin-bottom: 0px; font-size: 16px; line-height: 1.6; border: 0.6px solid black;">单价</th>
				<th style="margin-bottom: 0px; font-size: 16px; line-height: 1.6; border: 0.6px solid black;">货款</th>
			</tr>
			<tr>
				<td style="margin-bottom: 0px; font-size: 16px; line-height: 1.6; border: 0.6px solid black; text-align: center;">
					${isFieldChecked("goods", "goods_shuliang") ? product.num || "--" : "--"}
				</td>
				<td style="margin-bottom: 0px; font-size: 16px; line-height: 1.6; border: 0.6px solid black; text-align: center;">
					${product.weight || "--"}
				</td>
				<td style="margin-bottom: 0px; font-size: 16px; line-height: 1.6; border: 0.6px solid black; text-align: center;">
					${
						isFieldChecked("goods", "goods_danjia")
							? product.huozhu_num > 0
								? `(包)${product.price || "8"}元/${product.unit}`
								: `${product.price || "8"}元/${product.unit}`
							: "--"
					}
				</td>
				<td style="margin-bottom: 0px; font-size: 16px; line-height: 1.6; border: 0.6px solid black; text-align: center;">
					${isFieldChecked("goods", "goods_jiage") ? product.goods_price || "88元" : "--"}
				</td>
			</tr>
			<tr>
				<td colspan="4" style="margin-bottom: 0px; font-size: 13px; line-height: 1.6; border: 0.6px solid black; text-align: center;">
					<div style="width: 80%; margin: 0 auto;">`;

		if (product.order_detail_fujiafei == "测试") {
			printer_info.field.goods.forEach(item => {
				if (item.extend == "fujiafei" && item.checked) {
					html += `<span>` + item.field_name + `:6元</span> `;
				} else if (item.extend == "fujiafei") {
					html += `<span>` + item.field_name + `:--</span> `;
				}
			});
		} else {
			product.order_detail_fujiafei.forEach(itemj => {
				printer_info.field.goods.forEach(item => {
					if (
						item.extend == "fujiafei" &&
						item.checked &&
						item.field_name == itemj.name
					) {
						html +=
							`<span>` + item.field_name + `:` + itemj.total + `元</span> `;
					} else if (
						item.extend == "fujiafei" &&
						item.field_name == itemj.name
					) {
						html += `<span>` + item.field_name + `:--</span> `;
					}
				});
			});
		}

		html += `</div>
				</td>
			</tr>
		</table>
	`;
	});

	html += `
	<hr style="border-top: 1px dashed #000; margin: 10px -10px;" />
`;

	html += `<br>`;
	html += `<br>`;

	if (isFieldChecked("settle", "total_price")) {
		let youhui = "";
		if (details.youhui > 0) {
			youhui = " 优惠:" + details.youhui + "元";
		}
		if (details.duoshou > 0) {
			youhui = "多收:" + details.duoshou + "元";
		}

		if (details.huankuan) {
			let pay_str_now = "";
			pay_str_now =
				pay_str_now +
				(details.huankuan.cash_num > 0
					? " 现金:" + details.huankuan.cash_num
					: "");
			pay_str_now =
				pay_str_now +
				(details.huankuan.wepay_num > 0
					? " 微信:" + details.huankuan.wepay_num
					: "");
			pay_str_now =
				pay_str_now +
				(details.huankuan.alipay_num > 0
					? " 支付宝:" + details.huankuan.alipay_num
					: "");
			pay_str_now =
				pay_str_now +
				(details.huankuan.union_num > 0
					? " 银联:" + details.huankuan.union_num
					: "");
			pay_str_now =
				pay_str_now +
				(details.huankuan.other_num > 0
					? " 其他:" + details.huankuan.other_num
					: "");

			html += `
					<div style="font-weight: bold; font-size: 18px;">总计:${details.yingshou +
						details.shishou}元</div>
				`;
			html += `
					<div style="font-weight: bold; font-size: 18px;">本次还款:${details.huankuan.money}元</div>
				`;
			if (details.huan > details.huankuan.money) {
				html += `<div style="font-weight: bold; font-size: 18px;">累计还款:${details.huan}元</div>`;
			}
			html += `
					<div style="font-weight: bold; font-size: 18px;">下欠:${details.yingshou}元</div>
				`;
		} else {
			html += `
				<div style="font-weight: bold; font-size: 18px;">总计:${details.total_price ||
					"8"}元</div>
			`;
			if (youhui) {
				html += `
					<div style="font-weight: bold; font-size: 18px;">${youhui || "8"}</div>
				`;
			}
			if (details.huan) {
				html += `
							<div style="font-weight: bold; font-size: 18px;">累计还款:${details.huan ||
								"元"}元</div>
						`;
			}

			if (pay_status === "赊欠") {
				html += `
					<div style="font-weight: bold; font-size: 18px;">下欠:${details.yingshou ||
						"8"}元</div>
				`;
			} else {
				if (print_huozhu_chaifen == 1)
					html += `
					<div style="font-weight: bold; font-size: 18px;">实收:${details.shishou ||
						"8"}元</div>
				`;
			}
		}
	}

	if (isFieldChecked("other", "pay_qr_code")) {
		html += `
	<div style="text-align: right; margin: -40px 0;">
		<img src="${details.qrCodeImage}" alt="二维码" style="position: relative; top:-45px; width: 80px; height: 80px;" />
		<br />
		<a style="position: relative; top:-45px;">扫描上方二维码</a>
	</div>
	</div>
	`;
	}

	html += `<hr style="border-top: 1px dashed #000; margin: 5px 0;" />`;

	if (isFieldChecked("settle", "notes")) {
		html += `
	<div style="margin-bottom: 4px;">
		备注: ${details.notes || "备注信息"}
		<br />`;
	}

	if (isFieldChecked("settle", "sheqian") && details.sheqian > 0) {
		html +=
			`
		<div style="margin-bottom: 4px;">
			截止到:` +
			transTime(new Date().getTime()) +
			`
			<br />`;
	}

	if (isFieldChecked("settle", "sheqian") && details.sheqian > 0) {
		html += `<span style="font-weight:bold;font-size:18px">
				累计赊欠: ${details.sheqian || "88"}元</span>
				<br />`;
	}

	if (isFieldChecked("settle", "add_time")) {
		html += ` 开单时间: ${details.add_time || "2025-3-3 11:30:30"}
		<br />
		`;
	}

	if (isFieldChecked("settle", "print_time")) {
		html +=
			` 打印时间: ` +
			transTime(new Date().getTime()) +
			`
		<br />
		`;
	}

	let pay_str = "";
	pay_str = pay_str + (details.cash_num ? " 现金:" + details.cash_num : "");
	pay_str = pay_str + (details.wepay_num ? " 微信:" + details.wepay_num : "");
	pay_str =
		pay_str + (details.alipay_num ? " 支付宝:" + details.alipay_num : "");
	pay_str = pay_str + (details.union_num ? " 银联:" + details.union_num : "");
	pay_str = pay_str + (details.other_num ? " 其他:" + details.other_num : "");

	if (isFieldChecked("pay", "zhifufangshi") && pay_str) {
		html +=
			` 支付方式: ` +
			pay_str +
			`
		<br />
		`;
	}

	if (isFieldChecked("other", "mobile")) {
		html += `档口电话: ${userinfo.dangkou_phone || "17720498851"}
	`;
	}

	if (isFieldChecked("other", "address")) {
		html += `
		<br />
		档口地址: ${userinfo.dangkou_address || "武汉市新华南综合市场B10-01"}
	`;
	}

	html += `
	</div>
`;
	html += `
	<div>${details.disclaimer ||
		"以上食用农产品均履行进货检查法定程序索证索票齐全销售者特此声明。"}</div>
`;

	html += `
	<div style="display: flex; align-items: center; margin-top: 15px; padding-right: 4px;">
		<div style="flex: 0 0 auto; margin-right: 8px;">
			<img src="../../static/logo.jpeg" alt="云批宝" style="width: 50px; height: 50px;" />
		</div>
		<div style="width: 2px; background-color: rgb(72, 208, 102); height: 50px; margin-right: 4px;"></div>
		<div style="flex: 1;">
			<div style="color: rgb(72, 208, 102); font-size: 16px;">云批宝，专业农批收银管理系统</div>
			<div style="color: rgb(254, 159, 76); font-size: 13px; margin-top: 3px;">免费试用欢迎咨询电话: 400-765-6785</div>
		</div>
	</div>
	`;

	html += `
	</div>
`;

	return html;
}

//
export function generatePrintContent4(details, transTime) {
	let printer_info = JSON.parse(localStorage.getItem("printer_info"));
	let userinfo = JSON.parse(localStorage.getItem("userInfo"));

	let html = `
	<div style="
		position: relative;
		width: 100%;
		height: 600px;
		overflow: visible;
	">
		<div style="
			position: absolute;
			left: 50%;
			top: 50%;
			width: 160mm;
			height: 80mm;
			padding: 5px;
			box-sizing: border-box;
			line-height: 1.1;
			transform: translate(-50%, -50%) rotate(90deg);
			transform-origin: center center;
			color: #000;
			background-color: #fff;
		">
`;

	html += `
		<div style="display: flex; justify-content: space-between; margin-bottom: -10px; font-weight: bold;"> `;

	let pay_status = "";
	if (details.yingshou <= 0) {
		pay_status = "已付款";
	} else {
		if (details.yingshou == details.shishou) {
			pay_status = "未付款";
		} else {
			pay_status = "赊欠  ";
		}
	}

	if (isFieldChecked("header", "order_status")) {
		html += `<div style="font-size: 24px;">${pay_status}</div>`;
	} else {
		html += `<div style="font-size: 24px;color:#ffffff">0000</div>`;
	}

	if (isFieldChecked("header", "deal_address")) {
		html += `<div style="font-size: 16px; font-weight: 200; text-align: center;" >${userinfo.area}</div>`;
	} else {
		html += `<div style="font-size: 16px; font-weight: 200; text-align: center; color:#ffffff"" >000</div>`;
	}

	if (details.notes && details.notes.trim() !== "") {
		html += `<div style="font-size: 14px; text-align: center; margin-bottom: 5px;">备注: ${details.notes}</div>`;
	}

	html += `<div style="text-align: right;">`;
	if (isFieldChecked("header", "cashier_id")) {
		html += `<span style="font-size: 20px;">${details.user.name ||
			"系统操作员A"}</span>`;
	} else {
		html += `<span style="font-size: 20px;color:#ffffff">00</span>`;
	}
	if (isFieldChecked("header", "piao_num")) {
		html += `<span style="font-size: 20px;">${details.piao_num ||
			"009"}</span>`;
	} else {
		html += `<span style="font-size: 20px;color:#ffffff">00</span>`;
	}
	html += `</div>`;

	html += `</div>
	`;

	if (isFieldChecked("header", "voucher")) {
		html += `
			<div style="display: flex; justify-content: center; margin-bottom: 5px; font-weight: bold;">
				<div style="font-size: 24px;">${userinfo.dangkou_name}-销售凭证</div>
			</div>
	`;
	}

	html += ``;

	details.order_detail.forEach((product, index) => {
		let productLeft = "";
		let productRight = "";

		if (isFieldChecked("goods", "goods_name")) {
			productLeft = `${index + 1}.${product.goods_name || "海南大香蕉"}`;
		}
		if (isFieldChecked("goods", "goods_jiage")) {
			productRight = `小计:${product.subtotal || "8.88元"}元`;
		}

		if (isFieldChecked("settle", "add_time")) {
			html +=
				`
			<div style="display: flex; justify-content: space-between; margin-bottom: 5px; font-weight: bold;">
				<div style="font-size: 24px;">买家:${details.maijia}</div>
				<div style="font-size: 15px; margin-bottom: -15px; font-weight: 400; display: flex; align-items: center;">开票日期:` +
				getGurrentTime() +
				` &nbsp;赊账日期: ${details.add_time || "2024-12-20 15:20"}</div>
			</div>`;
		} else {
			html += `
			<div style="display: flex; justify-content: space-between; margin-bottom: 5px; font-weight: bold;">
				<div style="font-size: 24px;">买家:${details.maijia}</div>
			</div>
		`;
		}

		html += `
		<table border="1" style="width: 100%; table-layout: fixed; border-collapse: collapse; margin-bottom: 5px; border: 0.6px solid black; font-size: 16px;">
			<tr>
				<th style="width: 16%; margin-bottom: 0px; font-size: 16px; line-height: 2.5; border: 0.6px solid black;">品名</th>
				<th style="width: 16%; margin-bottom: 0px; font-size: 16px; line-height: 2.5; border: 0.6px solid black;">货主</th>
				<th style="width: 14%; margin-bottom: 0px; font-size: 16px; line-height: 2.5; border: 0.6px solid black;">数量</th>
				<th style="width: 14%; margin-bottom: 0px; font-size: 16px; line-height: 2.5; border: 0.6px solid black;">重量</th>
				<th style="width: 14%; margin-bottom: 0px; font-size: 16px; line-height: 2.5; border: 0.6px solid black;">单价</th>
				<th style="width: 16%; margin-bottom: 0px; font-size: 16px; line-height: 2.5; border: 0.6px solid black;">货款</th>
			</tr>
			<tr>
				<th style="margin-bottom: 0px; font-size: 16px; line-height: 2.5; border: 0.6px solid black; word-break: break-all;">
					${
						isFieldChecked("goods", "goods_name")
							? index + 1 + "." + (product.goods_name || "海南大香蕉")
							: "--"
					}
				</th>
				 <th style="margin-bottom: 0px; font-size: 16px; line-height: 2; border: 0.6px solid black; word-break: break-all;">`;
		if (isFieldChecked("goods", "huozhupici")) {
			if (product.order_detail_pici) {
				html +=
					product.order_detail_pici.huozhu_name +
					product.order_detail_pici.pici;
			} else {
				html += "--";
			}
		} else {
			html += "--";
		}

		html += `</th><th style="margin-bottom: 0px; font-size: 16px; line-height: 2.5; border: 0.6px solid black;">
					${isFieldChecked("goods", "goods_shuliang") ? product.num || "--" : "--"}

				</th>
				<th style="margin-bottom: 0px; font-size: 16px; line-height: 2.5; border: 0.6px solid;">
					${product.weight || "--"}
				</th>
				<th style="margin-bottom: 0px; font-size: 16px; line-height: 2.5; border: 0.6px solid black;">
					${
						isFieldChecked("goods", "goods_danjia")
							? product.huozhu_num > 0
								? "(包)" + (product.price || "8元") + "/公斤"
								: (product.price || "8元") + "/公斤"
							: "--"
					}
				</th>
				<th style="margin-bottom: 0px; font-size: 16px; line-height: 2.5; border: 0.6px solid black;">
					${isFieldChecked("goods", "goods_jiage") ? product.goods_price || "--" : "--"}
				</th>
			</tr>
			<tr>
				<th colspan="4" style="margin-bottom: 0px; font-size: 13px; line-height: 2.5; border: 0.6px solid black; text-align: left; padding-left: 5px;">
					<div style="display: flex; flex-wrap: wrap; justify-content: flex-start; width: 100%;">`;

		if (product.order_detail_fujiafei == "测试") {
			printer_info.field.goods.forEach(item => {
				if (item.extend == "fujiafei" && item.checked) {
					html +=
						`<span style="margin-right: 15px; white-space: nowrap;">` +
						item.field_name +
						`:6元</span> `;
				} else if (item.extend == "fujiafei") {
					html +=
						`<span style="margin-right: 15px; white-space: nowrap;">` +
						item.field_name +
						`:--</span> `;
				}
			});
		} else {
			product.order_detail_fujiafei.forEach(itemj => {
				printer_info.field.goods.forEach(item => {
					if (
						item.extend == "fujiafei" &&
						item.checked &&
						itemj.name == item.field_name
					) {
						html +=
							`<span style="margin-right: 15px; white-space: nowrap;">` +
							item.field_name +
							`:` +
							itemj.total +
							`元</span> `;
					} else if (
						item.extend == "fujiafei" &&
						itemj.name == item.field_name
					) {
						html +=
							`<span style="margin-right: 15px; white-space: nowrap;">` +
							item.field_name +
							`:--</span> `;
					}
				});
			});
		}

		html += `</div>
				</th>
				<th colspan="2" style="margin-bottom: 0px; font-size: 16px; line-height: 2.5; border: 0.6px solid black;">
					<div>
						<span>小计:${
							isFieldChecked("goods", "goods_total")
								? product.total_price || "88"
								: "--"
						}元</span>
					</div>
				</th>
			</tr>
		</table>
	`;
	});

	let hasNotes =
		isFieldChecked("settle", "notes") &&
		details.notes &&
		details.notes.trim() !== "";
	let hasSalesperson =
		details.user && details.user.name && details.user.name.trim() !== "";
	let hasPhone =
		isFieldChecked("other", "mobile") &&
		userinfo.dangkou_phone &&
		userinfo.dangkou_phone.trim() !== "";
	let hasAddress =
		isFieldChecked("other", "address") &&
		userinfo.dangkou_address &&
		userinfo.dangkou_address.trim() !== "";
	let hasStatement = true;

	// 二维码定位
	if (isFieldChecked("other", "pay_qr_code")) {
		html += `
		<div style="position: absolute; right: 5px; bottom: 5px; text-align: right;">
			<img src="${details.qrCodeImage}" alt="二维码" style="width: 60px; height: 60px;" />
			<div style="font-size: 14px; text-align: center;">扫码付款</div>
		</div>
		`;
	}

	let fields = [];
	if (hasNotes) fields.push({ label: "备注", value: details.notes });
	if (hasSalesperson)
		fields.push({ label: "销售员", value: details.user.name });
	if (hasPhone)
		fields.push({ label: "档口电话", value: userinfo.dangkou_phone });
	if (hasAddress)
		fields.push({ label: "档口地址", value: userinfo.dangkou_address });

	html += `<table border="1" style="width: calc(100% - 70px); table-layout: fixed; border-collapse: collapse; border: 1px solid #000;">`;

	// 固定的行高
	const cellHeight = "30px";

	// 生成前四个字段的2x2布局
	if (fields.length > 0) {
		// 第一行
		html += `<tr style="height: ${cellHeight};">`;
		if (fields.length > 0) {
			html += `<td style="font-size: 14px; padding: 5px; border: 1px solid #000; height: ${cellHeight};">${fields[0].label}: ${fields[0].value}</td>`;
		} else {
			html += `<td style="font-size: 14px; padding: 5px; border: 1px solid #000; height: ${cellHeight};">&nbsp;</td>`;
		}
		if (fields.length > 1) {
			html += `<td style="font-size: 14px; padding: 5px; border: 1px solid #000; height: ${cellHeight};">${fields[1].label}: ${fields[1].value}</td>`;
		} else {
			html += `<td style="font-size: 14px; padding: 5px; border: 1px solid #000; height: ${cellHeight};">&nbsp;</td>`;
		}
		html += `</tr>`;

		// 第二行
		html += `<tr style="height: ${cellHeight};">`;
		if (fields.length > 2) {
			html += `<td style="font-size: 14px; padding: 5px; border: 1px solid #000; height: ${cellHeight};">${fields[2].label}: ${fields[2].value}</td>`;
		} else {
			html += `<td style="font-size: 14px; padding: 5px; border: 1px solid #000; height: ${cellHeight};">&nbsp;</td>`;
		}
		if (fields.length > 3) {
			html += `<td style="font-size: 14px; padding: 5px; border: 1px solid #000; height: ${cellHeight};">${fields[3].label}: ${fields[3].value}</td>`;
		} else {
			html += `<td style="font-size: 14px; padding: 5px; border: 1px solid #000; height: ${cellHeight};">&nbsp;</td>`;
		}
		html += `</tr>`;
	}
	html += `
		<tr>
			<td colspan="2" style="font-size: 12px; padding: 5px; border: 1px solid #000; line-height: 1.2;">
				以上食用农产品均履行进货检查法定程序索证索票齐全销售者特此声明。
			</td>
		</tr>
	`;
	html += `</table>`;
	html += `
	<div style="display: flex; align-items: center; margin-top: 6px; padding: 0 5px;">
		<div style="flex: 0 0 auto; margin-right: 8px;">
			<img src="../../static/logo.jpeg" alt="云批宝" style="width: 50px; height: 50px;" />
		</div>
		<div style="width: 2px; background-color: rgb(72, 208, 102); height: 40px; margin-right: 8px;"></div>
		<div style="flex: 1;">
			<div style="color: rgb(72, 208, 102); font-size: 16px;">云批宝，专业农批收银管理系统</div>
			<div style="color: rgb(254, 159, 76); font-size: 12px; margin-top: 2px;">免费试用欢迎咨询电话: 400-765-6785</div>
		</div>
	</div>
	`;

	html += `
		</div>
	</div>
	`;

	return html;
}
export function generatePrintContent5(
	details,
	transTime,
) {
	let printer_info = JSON.parse(localStorage.getItem("printer_info"));
	let userinfo = JSON.parse(localStorage.getItem("userInfo"));

	let html = `
	<div style="
		position: relative;
		width: 550px;
		margin: 0 auto;
		padding: 10px;
		box-sizing: border-box;
		background-color: #fff;
	">
`;

	html += `
		<div style="display: flex; justify-content: space-between; margin-bottom: 10px; font-weight: bold;"> `;

	let pay_status = "";
	if (details.yingshou <= 0) {
		pay_status = "已付款";
	} else {
		if (details.yingshou == details.shishou) {
			pay_status = "未付款";
		} else {
			pay_status = "赊欠  ";
		}
	}

	if (isFieldChecked("header", "order_status")) {
		html += `<div style="font-size: 24px;">${pay_status}</div>`;
	} else {
		html += `<div style="font-size: 24px;color:#ffffff">0000</div>`;
	}

	if (isFieldChecked("header", "deal_address")) {
		html += `<div style="font-size: 16px; font-weight: 200; text-align: center;" >${userinfo.area}</div>`;
	} else {
		html += `<div style="font-size: 16px; font-weight: 200; text-align: center; color:#ffffff"" >000</div>`;
	}

	if (isFieldChecked("header", "cashier_id")) {
		html += `<div style="text-align: right;">
			<span style="font-size: 20px;">${details.user.name || "系统操作员A"}</span>`;

		if (isFieldChecked("header", "piao_num")) {
			html += `<span style="font-size: 20px;">${details.piao_num || "009"}</span>`;
		}
		html += `</div>`;
	} else if (isFieldChecked("header", "piao_num")) {
		html += `<div style="text-align: right;">
			<span style="font-size: 20px;">${details.piao_num || "009"}</span>
		</div>`;
	} else {
		html += `<div style="text-align: right;">
			<span style="font-size: 20px;color:#ffffff">00</span>
		</div>`;
	}

	html += `</div>`;

	if (isFieldChecked("header", "voucher")) {
		html += `
			<div style="display: flex; justify-content: center; margin-bottom: 10px; font-weight: bold;">
				<div style="font-size: 24px;">${userinfo.dangkou_name}-销售凭证</div>
			</div>
		`;
	}

	if (details.notes && details.notes.trim() !== "") {
		html += `<div style="font-size: 14px; text-align: center; margin-bottom: 10px;">备注: ${details.notes}</div>`;
	}

	details.order_detail.forEach((product, index) => {
		if (isFieldChecked("settle", "add_time")) {
			html += `
				<div style="margin-bottom: 10px;">
					<div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 5px;">
						<div style="font-size: 22px; font-weight: bold; white-space: nowrap;">买家:${details.maijia}</div>
					</div>
					<div style="display: flex; justify-content: flex-end; font-size: 13px; margin-bottom: 5px;">
						<div style="white-space: nowrap;">开票日期:${getGurrentTime()}</div>
						<div style="white-space: nowrap; margin-left: 10px;">赊账日期:${details.add_time || "2024-12-20 15:20"}</div>
					</div>
				</div>
			`;
		} else {
			html += `
				<div style="margin-bottom: 10px;">
					<div style="font-size: 22px; font-weight: bold;">买家:${details.maijia}</div>
				</div>
			`;
		}

		html += `
		<table border="1" style="width: 100%; table-layout: fixed; border-collapse: collapse; margin-bottom: 10px; border: 0.6px solid black; font-size: 16px;">
			<tr>
				<th style="width: 16%; margin-bottom: 0px; font-size: 16px; line-height: 2.5; border: 0.6px solid black;">品名</th>
				<th style="width: 16%; margin-bottom: 0px; font-size: 16px; line-height: 2.5; border: 0.6px solid black;">货主</th>
				<th style="width: 14%; margin-bottom: 0px; font-size: 16px; line-height: 2.5; border: 0.6px solid black;">数量</th>
				<th style="width: 14%; margin-bottom: 0px; font-size: 16px; line-height: 2.5; border: 0.6px solid black;">重量</th>
				<th style="width: 14%; margin-bottom: 0px; font-size: 16px; line-height: 2.5; border: 0.6px solid black;">单价</th>
				<th style="width: 16%; margin-bottom: 0px; font-size: 16px; line-height: 2.5; border: 0.6px solid black;">货款</th>
			</tr>
			<tr>
				<th style="margin-bottom: 0px; font-size: 16px; line-height: 2.5; border: 0.6px solid black; word-break: break-all;">
					${
						isFieldChecked("goods", "goods_name")
							? index + 1 + "." + (product.goods_name || "海南大香蕉")
							: "--"
					}
				</th>
				 <th style="margin-bottom: 0px; font-size: 16px; line-height: 2; border: 0.6px solid black; word-break: break-all;">`;
		if (isFieldChecked("goods", "huozhupici")) {
			if (product.order_detail_pici) {

				html +=
					product.order_detail_pici.huozhu_name +
					product.order_detail_pici.pici;
			} else {
				html += "--";
			}
		} else {
			html += "--";
		}

		html += `</th><th style="margin-bottom: 0px; font-size: 16px; line-height: 2.5; border: 0.6px solid black;">
					${isFieldChecked("goods", "goods_shuliang") ? product.num || "--" : "--"}

				</th>
				<th style="margin-bottom: 0px; font-size: 16px; line-height: 2.5; border: 0.6px solid;">
					${product.weight || "--"}
				</th>
				<th style="margin-bottom: 0px; font-size: 16px; line-height: 2.5; border: 0.6px solid black;">
					${
						isFieldChecked("goods", "goods_danjia")
							? product.huozhu_num > 0
								? "(包)" + (product.price || "8元") + "/公斤"
								: (product.price || "8元") + "/公斤"
							: "--"
					}
				</th>
				<th style="margin-bottom: 0px; font-size: 16px; line-height: 2.5; border: 0.6px solid black;">
					${isFieldChecked("goods", "goods_jiage") ? product.goods_price || "--" : "--"}
				</th>
			</tr>
			<tr>
				<th colspan="4" style="margin-bottom: 0px; font-size: 13px; line-height: 2.5; border: 0.6px solid black; text-align: left; padding-left: 5px;">
					<div style="display: flex; flex-wrap: wrap; justify-content: flex-start; width: 100%;">`;

		if (product.order_detail_fujiafei == "测试") {
			printer_info.field.goods.forEach(item => {
				if (item.extend == "fujiafei" && item.checked) {
					html +=
						`<span style="margin-right: 15px; white-space: nowrap;">` +
						item.field_name +
						`:6元</span> `;
				} else if (item.extend == "fujiafei") {
					html +=
						`<span style="margin-right: 15px; white-space: nowrap;">` +
						item.field_name +
						`:--</span> `;
				}
			});
		} else {
			product.order_detail_fujiafei.forEach(itemj => {
				printer_info.field.goods.forEach(item => {
					if (
						item.extend == "fujiafei" &&
						item.checked &&
						itemj.name == item.field_name
					) {
						html +=
							`<span style="margin-right: 15px; white-space: nowrap;">` +
							item.field_name +
							`:` +
							itemj.total +
							`元</span> `;
					} else if (
						item.extend == "fujiafei" &&
						itemj.name == item.field_name
					) {
						html +=
							`<span style="margin-right: 15px; white-space: nowrap;">` +
							item.field_name +
							`:--</span> `;
					}
				});
			});
		}

		html += `</div>
				</th>
				<th colspan="2" style="margin-bottom: 0px; font-size: 16px; line-height: 2.5; border: 0.6px solid black;">
					<div>
						<span>小计:${
							isFieldChecked("goods", "goods_total")
								? product.total_price || "88"
								: "--"
						}元</span>
					</div>
				</th>
			</tr>
		</table>
	`;
	});

	let hasNotes =
		isFieldChecked("settle", "notes") &&
		details.notes &&
		details.notes.trim() !== "";
	let hasSalesperson =
		details.user && details.user.name && details.user.name.trim() !== "";
	let hasPhone =
		isFieldChecked("other", "mobile") &&
		userinfo.dangkou_phone &&
		userinfo.dangkou_phone.trim() !== "";
	let hasAddress =
		isFieldChecked("other", "address") &&
		userinfo.dangkou_address &&
		userinfo.dangkou_address.trim() !== "";
	let hasStatement = true;

	let fields = [];
	if (hasNotes) fields.push({ label: "备注", value: details.notes });
	if (hasSalesperson)
		fields.push({ label: "销售员", value: details.user.name });
	if (hasPhone)
		fields.push({ label: "档口电话", value: userinfo.dangkou_phone });
	if (hasAddress)
		fields.push({ label: "档口地址", value: userinfo.dangkou_address });

	let tableWidth = "calc(100% - 70px)";

	if (isFieldChecked("other", "pay_qr_code")) {
		html += `
		<div style="position: relative; margin-bottom: 10px; width: 100%;">
			<div style="position: absolute; right: 0; bottom: 0; text-align: right; z-index: 10; padding: 5px;">
				<img src="${details.qrCodeImage}" alt="二维码" style="width: 60px; height: 60px; display: block;" />
				<div style="font-size: 14px; text-align: center;">扫码付款</div>
			</div>
		`;
	} else {
		tableWidth = "100%";
		html += `<div style="position: relative; margin-bottom: 10px; width: 100%;">`;
	}

	html += `<table border="1" style="width: ${tableWidth}; table-layout: fixed; border-collapse: collapse; border: 1px solid #000;">`;

	const cellHeight = "30px";

	if (fields.length > 0) {
		html += `<tr style="height: ${cellHeight};">`;
		if (fields.length > 0) {
			html += `<td style="font-size: 14px; padding: 5px; border: 1px solid #000; height: ${cellHeight};">${fields[0].label}: ${fields[0].value}</td>`;
		} else {
			html += `<td style="font-size: 14px; padding: 5px; border: 1px solid #000; height: ${cellHeight};">&nbsp;</td>`;
		}
		if (fields.length > 1) {
			html += `<td style="font-size: 14px; padding: 5px; border: 1px solid #000; height: ${cellHeight};">${fields[1].label}: ${fields[1].value}</td>`;
		} else {
			html += `<td style="font-size: 14px; padding: 5px; border: 1px solid #000; height: ${cellHeight};">&nbsp;</td>`;
		}
		html += `</tr>`;

		html += `<tr style="height: ${cellHeight};">`;
		if (fields.length > 2) {
			html += `<td style="font-size: 14px; padding: 5px; border: 1px solid #000; height: ${cellHeight};">${fields[2].label}: ${fields[2].value}</td>`;
		} else {
			html += `<td style="font-size: 14px; padding: 5px; border: 1px solid #000; height: ${cellHeight};">&nbsp;</td>`;
		}
		if (fields.length > 3) {
			html += `<td style="font-size: 14px; padding: 5px; border: 1px solid #000; height: ${cellHeight};">${fields[3].label}: ${fields[3].value}</td>`;
		} else {
			html += `<td style="font-size: 14px; padding: 5px; border: 1px solid #000; height: ${cellHeight};">&nbsp;</td>`;
		}
		html += `</tr>`;
	}
	html += `
		<tr>
			<td colspan="2" style="font-size: 12px; padding: 5px; border: 1px solid #000; line-height: 1.2;">
				以上食用农产品均履行进货检查法定程序索证索票齐全销售者特此声明。
			</td>
		</tr>
	`;
	html += `</table>`;

	html += `</div>`;

	html += `
	<div style="display: flex; align-items: center; margin-top: 6px; padding: 0 5px;">
		<div style="flex: 0 0 auto; margin-right: 8px;">
			<img src="../../static/logo.jpeg" alt="云批宝" style="width: 50px; height: 50px;" />
		</div>
		<div style="width: 2px; background-color: rgb(72, 208, 102); height: 40px; margin-right: 8px;"></div>
		<div style="flex: 1;">
			<div style="color: rgb(72, 208, 102); font-size: 16px;">云批宝，专业农批收银管理系统</div>
			<div style="color: rgb(254, 159, 76); font-size: 12px; margin-top: 2px;">免费试用欢迎咨询电话: 400-765-6785</div>
		</div>
	</div>
	`;

	html += `</div>`;

	return html;
}
export async function executeShare(templateType, loading, printContent) {
	const tempContainer = document.createElement("div");
	const isRotatedTemplate = templateType === 4;

	  tempContainer.style.width = isRotatedTemplate ? "80mm" : "80mm";
	tempContainer.style.padding = "0px";
	tempContainer.style.boxSizing = "border-box";
	tempContainer.style.fontSize = "12px";
	tempContainer.style.lineHeight = "1.5";
	tempContainer.style.color = "#000";
	tempContainer.style.backgroundColor = "#fff";
	tempContainer.innerHTML = printContent;
	tempContainer.style.position = "absolute";
	tempContainer.style.left = "-9999px";
	document.body.appendChild(tempContainer);
	// alert(555)
	try {
		await waitForImagesToLoad(tempContainer);
		const printCanvas = await html2canvas(tempContainer, {
			useCORS: true,
			scale: 2
		});

		const imgData = printCanvas.toDataURL("image/png");



console.log(imgData);


		const base64Data = imgData.replace(/^data:image\/png;base64,/, "");

		document.body.removeChild(tempContainer);
		window.Android.shareBase64Image(base64Data, "1.png");
		// window.Android.shareBase64Image(res.data,"1.png");
	} catch (error) {
		console.error("打印失败:", error);
		throw new Error("错误:" + error.message);
	}
}
export async function executeShare2(
  templateType,
  loading,
  printContent,
  width = 750,
  height = 500
) {
  try {
    if (loading) loading.value = true;

    const tempContainer = document.createElement("div");
    document.body.appendChild(tempContainer);

    tempContainer.style.position = "fixed";
    tempContainer.style.left = "0";
    tempContainer.style.top = "0";
    tempContainer.style.minWidth = "800px";
    tempContainer.style.minHeight = "1000px";
    tempContainer.style.padding = "0";
    tempContainer.style.margin = "0";
    tempContainer.style.boxSizing = "border-box";
    tempContainer.style.backgroundColor = "#fff";
    tempContainer.style.zIndex = "-1000";
    tempContainer.style.overflow = "visible";

    tempContainer.innerHTML = printContent;

    const centerDiv = tempContainer.querySelector('div[style*="position: absolute"][style*="left: 50%"]');
    if (centerDiv) {
      centerDiv.style.transform = "none";
      centerDiv.style.position = "relative";
      centerDiv.style.left = "auto";
      centerDiv.style.top = "auto";
      centerDiv.style.width = "550px";
      centerDiv.style.margin = "0 auto";
    }

    await new Promise(resolve => setTimeout(resolve, 500));
    await waitForImagesToLoad(tempContainer);

    const printCanvas = await html2canvas(tempContainer, {
      useCORS: true,
      scale: 1.5,
      logging: false,
      allowTaint: true,
      backgroundColor: "#fff",
      width: width || 750,
      height: height || 1000,
      onclone: (document, clone) => {
        const centerDivClone = clone.querySelector('div[style*="position: absolute"][style*="left: 50%"]');
        if (centerDivClone) {
          centerDivClone.style.transform = "none";
          centerDivClone.style.position = "relative";
          centerDivClone.style.left = "auto";
          centerDivClone.style.top = "auto";
          centerDivClone.style.width = "550px";
          centerDivClone.style.margin = "0 auto";
        }

        const qrCodeImg = clone.querySelector('img[alt="二维码"]');
        if (qrCodeImg) {
          let parent = qrCodeImg.parentElement;
          while (parent) {
            parent.style.visibility = "visible";
            parent.style.display = parent.tagName === 'DIV' ? 'block' : '';
            parent.style.zIndex = "1000";
            parent = parent.parentElement;
          }
        }

        return clone;
      }
    });

    const imgData = printCanvas.toDataURL("image/png");
    const base64Data = imgData.replace(/^data:image\/png;base64,/, "");
    console.log(base64Data);
    document.body.removeChild(tempContainer);

    window.Android.shareBase64Image(base64Data, "1.png");
  } catch (error) {
    console.error("打印失败:", error);
    throw new Error("错误:" + error.message);
  }
}
export async function executePrint(templateType, loading, printContent) {
	const tempContainer = document.createElement("div");
	const isRotatedTemplate = templateType === 4;

	tempContainer.style.width = isRotatedTemplate ? "80mm" : "80mm";
	tempContainer.style.padding = "0px";
	tempContainer.style.boxSizing = "border-box";
	tempContainer.style.fontSize = "12px";
	tempContainer.style.lineHeight = "1.5";
	tempContainer.style.color = "#000";
	tempContainer.style.backgroundColor = "#fff";
	tempContainer.innerHTML = printContent;
	tempContainer.style.position = "absolute";
	tempContainer.style.left = "-9999px";
	document.body.appendChild(tempContainer);

	try {
		await waitForImagesToLoad(tempContainer);
		const printCanvas = await html2canvas(tempContainer, {
			useCORS: true,
			scale: 2
		});

		const imgData = printCanvas.toDataURL("image/png");

		const base64Data = imgData.replace(/^data:image\/png;base64,/, "");
		console.log(base64Data);
		document.body.removeChild(tempContainer);

		const printResult = window.Android.printBase64Picture(base64Data);

		setTimeout(() => {
			window.Android.pCutPaper(66, 50);
		}, 1000);

		return printResult;
	} catch (error) {
		console.error("打印失败:", error);
		throw new Error("错误:" + error.message);
	}
}

// 打印html内容
export async function executePrint2(templateType, loading, printContent) {
	const tempContainer = document.createElement("div");
	const isRotatedTemplate = templateType === 4;

	tempContainer.style.width = isRotatedTemplate ? "80mm" : "80mm";
	tempContainer.style.padding = "0px";
	tempContainer.style.boxSizing = "border-box";
	tempContainer.style.fontSize = "12px";
	tempContainer.style.lineHeight = "1.5";
	tempContainer.style.color = "#000";
	tempContainer.style.backgroundColor = "#fff";
	tempContainer.innerHTML = printContent;
	tempContainer.style.position = "absolute";
	tempContainer.style.left = "-9999px";
	document.body.appendChild(tempContainer);

	try {
		await waitForImagesToLoad(tempContainer);
		const printCanvas = await html2canvas(tempContainer, {
			useCORS: true,
			scale: 2
		});

		const imgData = printCanvas.toDataURL("image/png");
		const base64Data = imgData.replace(/^data:image\/png;base64,/, "");
		console.log(base64Data);
		document.body.removeChild(tempContainer);

		return window.Android.printBase64Picture(base64Data);
	} catch (error) {
		console.error("打印失败:", error);
		throw new Error("错误:" + error.message);
	}
}

export async function printSingleCopy(templateType, printContent) {
	try {
		await executePrint2(templateType, null, printContent);
		await new Promise(resolve => setTimeout(resolve, 1000));
		window.Android.pCutPaper(66, 50);
	} catch (error) {
		console.error("单次打印失败:", error);
		throw error;
	}
}



// WEBPACK FOOTER //
// ./src/api/index.js